<template>
  <div
    :class="$style.container"
    id="loading"
    v-loading.fullscreen.lock.body="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-container>
      <!--详情-->
      <el-dialog :visible.sync="dialogVisible" width="1220px" :show-close="false" style="vertical-align: center; :#FFF9F3 ">
        <div style="margin-top: -40px; min-heigh: 600px; overflow: auto">
          <el-row style="padding-bottom: 10px; display: flex">
            <el-col :span="9">
              <div
                style="
                  color: #3998f7;
                  padding-top: 8px;
                  font-size: 20px;
                  display: inline-block;
                "
              >
                {{ territory_name }} ({{ territory_code }})<span
                  style="
                    padding: 2px 3px;
                    border-radius: 2px;
                    color: white;
                    font-size: 12px;
                    margin-left: 15px;
                    position: relative;
                    top: -3px;
                    background: #ff9901;
                  "
                  >{{ owner_name }}</span
                >
              </div>
              <div style="width: 105px; display: inline-block; margin-left: 15px">
                <img
                  style="
                    position: relative;
                    top: 2px;
                    width: 15px;
                    height: 15px;
                  "
                  src="../../assets/images/left.png"
                  @click="dialogClickLeft"
                />
                <span style="color: #ff9900; font-size: 15px">{{ saleYear }}年</span>
                <img
                  style="
                    position: relative;
                    top: 2px;
                    width: 15px;
                    height: 15px;
                  "
                  src="../../assets/images/right.png"
                  @click="dialogClickRight"
                />
              </div>
            </el-col>
            <el-col :span="7">
              <el-radio-group v-model="radio2" style="width: 167px; margin: 0 auto" @change="fangfa2">
                <el-radio-button label="按产品" value="PRODUCT"></el-radio-button>
                <el-radio-button label="按客户" value="INSTITUTION"></el-radio-button>
              </el-radio-group>
            </el-col>
            <el-col :span="8">
              <div align="right">
                <el-button type="primary" size="small" @click="baocun">
                  保存
                </el-button>
                <el-button type="danger" size="small" @click="dialogVisible = false">
                  关闭
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-dialog>

      <div width="360px" id="jurisdiction">
        <div :class="$style.left" style="height: 100%; display: flex; flex-direction: column">
          <el-row>
            <el-col>
              <div style="padding-top: 8px; margin-bottom: 30px; font-weight: bold">
                销售数据管理
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 10px">
            <el-col :span="12" style="border: 1px solid transparent">
              <el-button type="success" style="background: #ff9901; border: 1px solid #ff9901" @click="jump" icon="el-icon-folder-delete" size="small">数据录入设定 </el-button>
            </el-col>
            <el-col :span="12" style="border: 1px solid transparent">
              <div align="right">
                <el-button type="danger" style="background: #4a90e2; border: 1px solid #4a90e2" icon="el-icon-download" size="small" @click="dianji">
                  导入导出
                </el-button>
              </div>
            </el-col>
          </el-row>

          <el-row id="el-rowInput">
            <el-col>
              <el-autocomplete
                style="text-align: center"
                id="inputSeach"
                v-model="input"
                placeholder="请输入辖区名字进行快速检索 "
                :fetch-suggestions="search"
                @select="handleSelect"
                :class="$style.search"
              >
                <span slot-scope="{ item }">
                  <span style="margin-left: 21px; font-size: 14px; color: #555555" v-if="item.parent_name">{{ item.parent_name }} -</span>
                  <span>{{ item.territory_name }}</span>
                </span>
              </el-autocomplete>
            </el-col>
          </el-row>
          <div
            ref="scrollbar"
            style="
              border: 1px solid #dedede;
              height: 90%;
              border-top: none;
              flex-grow: 1;
              overflow: auto;
            "
          >
            <el-tree
              lazy
              :load="loadNode"
              class="SizeClass1"
              :data="folderArry"
              node-key="territory_id"
              @node-click="handleNodeClick"
              :props="defaultProps"
              :current-node-key="selectedTerritory"
              :highlight-current="true"
              :filter-node-method="filterNode"
              :expand-on-click-node="false"
              :auto-expand-parent="true"
              @node-expand="handleNodeExpand"
              ref="tree"
            >
              <span style="font-size: 16px" slot-scope="{ node }">
                <span
                  style="
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    margin: 0 10px 0 10px;
                  "
                >
                  <img style="line-height: 20px; position: relative; top: 2px" :src="node.data.territory_type == 'ENDPOINT' ? icon[1] : icon[0]" alt="" />
                </span>
                <span
                  v-if="node.data.territory_type != 'ENDPOINT'"
                  style="
                    line-height: 20px;
                    height: 20px;
                    display: inline-block;
                    position: relative;
                    top: -1px;
                  "
                  >{{ node.data.territory_name }}</span
                >
                <span
                  v-if="node.data.territory_type == 'ENDPOINT'"
                  style="
                    line-height: 20px;
                    height: 20px;
                    display: inline-block;
                    position: relative;
                    top: -1px;
                  "
                  >{{ node.data.territory_name }}&nbsp;&nbsp;&nbsp;<span v-if="node.data.territory_code != ''">({{ node.data.territory_code }})</span></span
                >
              </span>
            </el-tree>
          </div>
        </div>
      </div>

      <el-main>
        <el-row style="height: 56px; overflow: hidden; margin-top: 18px">
          <el-col style="width: 70%; border: 1px solid transparent; height: 100%">
            <div v-if="territory_region === '地区'" style="padding-top: 8px; float: left; height: 100%; width: 100%">
              <span style="color: #3b99f7; line-height: 50px">{{ territory_name }}</span>
              <p v-if="territory_level_name != ''" id="regionP">
                {{ territory_level_name }}
              </p>
              <p>hello</p>
              <span
                v-if="!salList"
                style="
                  padding: 0px 4px;
                  border-radius: 2px;
                  position: relative;
                  top: -1px;
                  color: white;
                  font-size: 12px;
                  background: #bbbbbb;
                "
                >无人管理</span
              >
            </div>

            <div v-if="territory_region === '终端'" style="height: 100%; overflow: hidden; float: left">
              <span style="color: #3b99f7; line-height: 68px">{{ territory_name }} ({{ territory_code }})</span>
            </div>

            <div v-if="territory_region === '终端'" align="left" style="height: 100%; color: cornflowerblue; float: left">
              <p
                v-if="owner_name != ''"
                style="
                  margin-left: 10px;
                  font-size: 12px;
                  margin-top: 24px;
                  color: #bbbbbb;
                "
              >
                <span
                  style="
                    display: inline-block;
                    padding: 4px 8px;
                    border-radius: 2px;
                    color: white;
                    background: #ff9901;
                  "
                  >{{ owner_name }}</span
                >&nbsp;
                <span>职务:&nbsp;{{ owner_title }}</span>
                <span></span>
              </p>
              <p
                v-if="owner_name == ''"
                style="
                  margin-left: 10px;
                  font-size: 12px;
                  margin-top: 24px;
                  color: #bbbbbb;
                "
              >
                <span
                  style="
                    display: inline-block;
                    padding: 4px 8px;
                    border-radius: 2px;
                    color: white;
                    background: #bbbbbb;
                  "
                  >无人负责</span
                >
              </p>
            </div>
          </el-col>

          <el-col style="width: 30%; font-size: 14px">
            <div style="float: right; margin-top: 20px">
              终端辖区
              <el-switch :disabled="true" v-model="terminal" active-color="#13ce66"> </el-switch>
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 6px">
          <el-col :span="24">
            <div style="border-bottom: 1px dashed #ededed"></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div align="left" style="padding-top: 15px; color: cornflowerblue" v-if="territory_region == '地区'">
              <span style="color: black; font-size: 14px">终端辖区{{ endPoint }}个 &nbsp; | &nbsp; 销售团队{{ salesTeam }}人</span>
            </div>

            <div align="left" style="padding-top: 15px; color: cornflowerblue" v-if="territory_region == '终端'">
              <span style="color: black; font-size: 14px"
                >机构 {{ institutionCount }} 家&nbsp; | &nbsp; 门店 {{ storeCount }} 家&nbsp; | &nbsp;经销商 {{ distributorCount }} 家</span
              >
            </div>
          </el-col>
          <el-col :span="12">
            <div align="right" style="margin-top: 15px">
              <img style="position: relative; top: 2px; width: 15px; height: 15px" src="../../assets/images/left.png" @click="clickLeft" />
              <span style="color: #ff9900">{{ saleYear }}年</span>
              <img style="position: relative; top: 2px; width: 15px; height: 15px" src="../../assets/images/right.png" @click="clickRight" />
            </div>
          </el-col>
        </el-row>

        <div style="width:100%;margin-top: 20px;">
          <el-table border :data="tableData1" style="display:flex;flex-direction: column; align-items: center;width: 100%;" :row-style="{ height: '35px' }">
            <el-table-column prop="institution_name" label="客户" header-align="center" align="center" min-width="45%"> </el-table-column>
            <el-table-column prop="sku_name" label="产品" header-align="center" align="center" min-width="35%"> </el-table-column>
            <el-table-column prop="week_actual_sales_amou nt" label="销量" header-align="center" align="center" min-width="20%"> </el-table-column>
          </el-table>
          <el-col style="margin-bottom: 20px">
            <pagination :page="page" @changePage="changePageClick"></pagination>
          </el-col>
        </div>
      </el-main>
      <!--导入导出 -->
      <el-dialog :visible.sync="dialogVisible2" width="850px" :show-close="false" style="vertical-align: center; :#FFF9F3 " :before-close="closeModal2">
        <div style="margin-top: -40px">
          <el-row style="padding-bottom: 10px">
            <el-col :span="12">
              <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
                数据导入与导出
              </div>
            </el-col>

            <el-col :span="12">
              <div align="right">
                <el-button type="danger" size="small" @click="closeModal2">
                  关闭
                </el-button>
              </div>
            </el-col>
          </el-row>
          <el-tabs v-model="activeNameImp">
            <el-tab-pane label="医疗机构" name="institution"> </el-tab-pane>
            <el-tab-pane label="零售门店" name="retailstore"> </el-tab-pane>
            <el-tab-pane label="分销客户" name="distributor"> </el-tab-pane>
          </el-tabs>
          <div class="subjectList" style="margin-top: 20px">
            <el-form ref="form" label-width="100px" :model="form" style="font-size: 14px">
              <el-row style="margin-left: 10px">
                <el-col>
                  <el-form-item label="下载指标数据">
                    <el-date-picker v-model="download.month1" type="month" value-format="yyyy-MM" placeholder="请选择月份"> </el-date-picker>

                    <el-button type="primary" size="small" :disabled="download.month1 == '' || download.month1 == null" style="margin-left: 21px" @click="xiazai('指标')"
                      >下载</el-button
                    >

                    <span style="font-size: 14px; color: #585757; margin-left: 11px"> <i class="el-icon-document"></i>{{ dialogConfig[activeNameImp].name }}销售指标.xls </span>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row style="margin-left: 10px">
                <el-col>
                  <el-form-item label="下载预估数据">
                    <el-date-picker v-model="download.month2" value-format="yyyy-MM" type="month" placeholder="请选择月份"> </el-date-picker>

                    <el-button type="primary" size="small" :disabled="download.month2 == '' || download.month2 == null" style="margin-left: 21px" @click="xiazai('预估')"
                      >下载</el-button
                    >

                    <span style="font-size: 14px; color: #585757; margin-left: 11px"> <i class="el-icon-document"></i>{{ dialogConfig[activeNameImp].name }}销量预估.xls </span>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row style="margin-left: 10px">
                <el-col>
                  <el-form-item label="下载销量数据">
                    <el-date-picker v-model="download.month3" value-format="yyyy-MM" type="month" placeholder="请选择月份"> </el-date-picker>

                    <el-button type="primary" size="small" :disabled="download.month3 == '' || download.month3 == null" style="margin-left: 21px" @click="xiazai('销量')"
                      >下载</el-button
                    >

                    <span style="font-size: 14px; color: #585757; margin-left: 11px"> <i class="el-icon-document"></i>{{ dialogConfig[activeNameImp].name }}实际销量.xls </span>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row style="margin-left: 10px; margin-top: 30px">
                <el-form-item label="销售指标模板">
                  <a
                    style="text-decoration: none; color: #ffff"
                    class="el-button el-button--primary el-button--small"
                    :href="`../../../static/${dialogConfig[activeNameImp].name}指标导入模板.xlsx`"
                    :download="`${dialogConfig[activeNameImp].name}指标数据导入模板.xlsx`"
                    >下载</a
                  >
                  <span style="font-size: 14px; color: #585757; margin-left: 11px">
                    <i class="el-icon-document"></i>{{ dialogConfig[activeNameImp].name }}指标数据导入模板.xls
                  </span>
                </el-form-item>
              </el-row>
              <el-row
                style="
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  padding-right: 30px;
                "
              >
                <el-form-item label="上传指标数据" style="margin-bottom: 0"> </el-form-item>
                <div
                  style="
                    border: 1px solid #ededed;
                    height: 30px;
                    flex-grow: 1;
                    margin-right: 20px;
                  "
                >
                  <span style="position: relative; top: 8px; left: 5px">{{ file1 }}</span>
                </div>
                <el-upload
                  class="upload-demo"
                  ref="upload1"
                  accept=".xlsx,.xls"
                  action=""
                  :file-list="fileList1"
                  :show-file-list="false"
                  :on-change="(file, fileList) => handleChange1(file, fileList, dialogConfig[activeNameImp].name)"
                  :limit="1"
                  :auto-upload="false"
                >
                  <el-button
                    slot="trigger"
                    size="small"
                    style="
                      background-color: #7ed321;
                      border: 1px solid #7ed321;
                      color: white;
                    "
                    >选择文件
                  </el-button>
                  <el-button style="margin-left: 10px" size="small" type="warning" @click="imortDataClick1(activeNameImp)">导入数据 </el-button>
                </el-upload>
              </el-row>

              <el-row style="margin-left: 10px; margin-top: 30px">
                <el-form-item label="销量预估模板">
                  <a
                    style="text-decoration: none; color: #ffff"
                    class="el-button el-button--primary el-button--small"
                    :href="`../../../static/${dialogConfig[activeNameImp].name}预估导入模板.xlsx`"
                    :download="`${dialogConfig[activeNameImp].name}预估数据导入模板.xlsx`"
                    >下载</a
                  >
                  <span style="font-size: 14px; color: #585757; margin-left: 11px">
                    <i class="el-icon-document"></i>{{ dialogConfig[activeNameImp].name }}预估数据导入模板.xls
                  </span>
                </el-form-item>
              </el-row>
              <el-row
                style="
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  padding-right: 30px;
                "
              >
                <el-form-item label="上传预估数据" style="margin-bottom: 0"> </el-form-item>
                <div
                  style="
                    border: 1px solid #ededed;
                    height: 30px;
                    flex-grow: 1;
                    margin-right: 20px;
                  "
                >
                  <span style="position: relative; top: 8px; left: 5px">{{ file2 }}</span>
                </div>
                <el-upload
                  class="upload-demo"
                  ref="upload2"
                  accept=".xlsx,.xls"
                  action=""
                  :file-list="fileList2"
                  :show-file-list="false"
                  :on-change="(file, fileList) => handleChange2(file, fileList, dialogConfig[activeNameImp].name)"
                  :limit="1"
                  :auto-upload="false"
                >
                  <el-button
                    slot="trigger"
                    size="small"
                    style="
                      background-color: #7ed321;
                      border: 1px solid #7ed321;
                      color: white;
                    "
                    >选择文件
                  </el-button>
                  <el-button style="margin-left: 10px" size="small" type="warning" @click="imortDataClick2(activeNameImp)">导入数据 </el-button>
                </el-upload>
              </el-row>

              <el-row style="margin-left: 10px; margin-top: 30px">
                <el-form-item label="实际销量模板">
                  <a
                    style="text-decoration: none; color: #ffff"
                    class="el-button el-button--primary el-button--small"
                    :href="`../../../static/${dialogConfig[activeNameImp].name}销量导入模板.xlsx`"
                    :download="`${dialogConfig[activeNameImp].name}销量数据导入模板.xlsx`"
                    >下载</a
                  >
                  <span style="font-size: 14px; color: #585757; margin-left: 11px">
                    <i class="el-icon-document"></i>{{ dialogConfig[activeNameImp].name }}销量数据导入模板.xls
                  </span>
                </el-form-item>
              </el-row>
              <el-row
                style="
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  padding-right: 30px;
                "
              >
                <el-form-item label="上传销量数据" style="margin-bottom: 0"> </el-form-item>
                <div
                  style="
                    border: 1px solid #ededed;
                    height: 30px;
                    flex-grow: 1;
                    margin-right: 20px;
                  "
                >
                  <span style="position: relative; top: 8px; left: 5px">{{ file3 }}</span>
                </div>
                <el-upload
                  class="upload-demo"
                  ref="upload3"
                  accept=".xlsx,.xls"
                  action=""
                  :file-list="fileList3"
                  :show-file-list="false"
                  :on-change="(file, fileList) => handleChange3(file, fileList, dialogConfig[activeNameImp].name)"
                  :limit="1"
                  :auto-upload="false"
                >
                  <el-button
                    slot="trigger"
                    size="small"
                    style="
                      background-color: #7ed321;
                      border: 1px solid #7ed321;
                      color: white;
                    "
                    >选择文件
                  </el-button>
                  <el-button style="margin-left: 10px" size="small" type="warning" @click="imortDataClick3(activeNameImp)">导入数据 </el-button>
                </el-upload>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-dialog>
      <!--指标导入报错信息-->
      <el-dialog :visible.sync="showModal1" :show-close="false" width="900px" style="margin-top: -20px">
        <div slot="title">
          <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
            <span style="color: #3998f7; font-size: 22px">错误提示</span>
            <span>
              <el-button type="primary" size="small" @click="handleExportData1">下载错误信息</el-button>
              <el-button type="danger" size="small" @click="showModal1 = false">关闭</el-button>
            </span>
          </div>
        </div>
        <el-table
          border
          :data="Mechanism1"
          stripe
          height="450px"
          style="width: 100%; margin-top: -20px"
          header-cell-class-name="headerStyle"
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <el-table-column type="index" :index="1" label="序号" style="font-size: 20px; color: #585757" width="75"></el-table-column>
          <el-table-column prop="month" label="月份" min-width="120px" sortable> </el-table-column>
          <el-table-column prop="code" :label="`${dialogConfig[activeNameImp].name}编码`" min-width="120px" sortable> </el-table-column>
          <el-table-column prop="name" :label="`${dialogConfig[activeNameImp].name}名称`" min-width="200px" sortable> </el-table-column>
          <el-table-column prop="sku_code" label="SKU编码" min-width="150px" sortable> </el-table-column>
          <el-table-column prop="sku_name" label="SKU名称" min-width="200px" sortable> </el-table-column>
          <el-table-column prop="number" label="指标（数量）" min-width="150px" sortable> </el-table-column>
          <el-table-column prop="amount" label="指标（金额）" min-width="150px" sortable> </el-table-column>
          <el-table-column fixed="right" label="报错信息" width="240px">
            <template slot-scope="scope">
              <div>
                <span style="font-size: 10px; color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--预估导入报错信息-->
      <el-dialog :visible.sync="showModal2" :show-close="false" width="900px" style="margin-top: -20px">
        <div slot="title">
          <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
            <span style="color: #3998f7; font-size: 22px">错误提示</span>
            <span>
              <el-button type="primary" size="small" @click="handleExportData2">下载错误信息</el-button>
              <el-button type="danger" size="small" @click="showModal2 = false">关闭</el-button>
            </span>
          </div>
        </div>
        <el-table
          border
          :data="Mechanism2"
          stripe
          height="450px"
          style="width: 100%; margin-top: -20px"
          header-cell-class-name="headerStyle"
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <el-table-column type="index" :index="1" label="序号" style="font-size: 20px; color: #585757" width="75"></el-table-column>
          <el-table-column prop="month" label="月份" min-width="120px" sortable> </el-table-column>
          <el-table-column prop="code" :label="`${dialogConfig[activeNameImp].name}编码`" min-width="120px" sortable> </el-table-column>
          <el-table-column prop="name" :label="`${dialogConfig[activeNameImp].name}名称`" min-width="200px" sortable> </el-table-column>
          <el-table-column prop="sku_code" label="SKU编码" min-width="150px" sortable> </el-table-column>
          <el-table-column prop="sku_name" label="SKU名称" min-width="200px" sortable> </el-table-column>
          <el-table-column prop="number" label="预估（数量）" min-width="150px" sortable> </el-table-column>
          <el-table-column prop="amount" label="预估（金额）" min-width="150px" sortable> </el-table-column>
          <el-table-column fixed="right" label="报错信息" width="240px">
            <template slot-scope="scope">
              <div>
                <span style="font-size: 10px; color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--销量导入报错信息-->
      <el-dialog :visible.sync="showModal3" :show-close="false" width="900px" style="margin-top: -20px">
        <div slot="title">
          <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
            <span style="color: #3998f7; font-size: 22px">错误提示</span>
            <span>
              <el-button type="primary" size="small" @click="handleExportData3">下载错误信息</el-button>
              <el-button type="danger" size="small" @click="showModal3 = false">关闭</el-button>
            </span>
          </div>
        </div>
        <el-table
          border
          :data="Mechanism3"
          stripe
          height="450px"
          style="width: 100%; margin-top: -20px"
          header-cell-class-name="headerStyle"
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <el-table-column type="index" :index="1" label="序号" style="font-size: 20px; color: #585757" width="75"></el-table-column>
          <el-table-column prop="month" label="月份" min-width="120px" sortable> </el-table-column>
          <el-table-column prop="code" :label="`${dialogConfig[activeNameImp].name}编码`" min-width="120px" sortable> </el-table-column>
          <el-table-column prop="name" :label="`${dialogConfig[activeNameImp].name}名称`" min-width="200px" sortable> </el-table-column>
          <el-table-column prop="sku_code" label="SKU编码" min-width="150px" sortable> </el-table-column>
          <el-table-column prop="sku_name" label="SKU名称" min-width="200px" sortable> </el-table-column>
          <el-table-column prop="number" label="销量（数量）" min-width="150px" sortable> </el-table-column>
          <el-table-column prop="amount" label="销量（金额）" min-width="150px" sortable> </el-table-column>
          <el-table-column fixed="right" label="报错信息" width="240px">
            <template slot-scope="scope">
              <div>
                <span style="font-size: 10px; color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import http from "../../APIService/http";
import jurisdiction from "../../assets/images/jurisdiction.png";
import jurisdiction2 from "../../assets/images/jurisdiction2.png";
import pagination from "../../components/pagination";
import { bus } from "../../router/index.js";
import { Message } from "element-ui";
import moment from "moment";
import xlsx from "xlsx";
import { export_json_to_excel } from "../../vendor/Export2Excel";
import axios from "axios";
export default {
  name: "home",
  data() {
    return {
      download: {
        month1: "",
        month2: "",
        month3: "",
      },
      tableData1: [],
      dialogConfig: {
        retailstore: {
          name: "门店",
        },
        institution: {
          name: "机构",
        },
        distributor: {
          name: "经销商",
        },
      },
      activeNameImp: "institution",
      activeName2: "",
      activeName: "",
      activeName3: "",
      form: {
        name: "",
        title: "",
        month: "",
      },
      dialogVisible2: false,
      radio2: "按产品",
      dialogVisible: false,
      institutionsArray: [],
      productCount: 0,
      institutionCount: 0,
      storeCount: 0,
      distributorCount: 0,
      radio1: "按产品",
      loading: false,
      loadingText: "拼命加载中",
      terminal: false,
      folderArry: [],
      level: 0,

      defaultProps: {
        label: "territory_name",
        children: "children",
        isLeaf: "leaf",
      },
      icon: [jurisdiction, jurisdiction2],
      territory_name: "",
      territory_region: "",
      territory_code: "",
      owner_name: "",
      owner_title: "",
      nodeData: {},
      sonNodeKey: [],
      territory_idd: "",
      parentNodeKey: "",
      sales_num: 0,
      terminal_num: 0,
      product_num: 0,
      productCount: "",
      endPoint: "",
      salesTeam: "",
      ContainerArray: [],
      skuArray: [],
      allArray: [],
      tableData: [],
      date: "",
      key: "PRODUCT",
      key2: "PRODUCT",
      SalesListArray: [],
      editAllArray: [],
      dialogActive1: "",
      dialogActive2: "",
      fileList1: [],
      fileList2: [],
      fileList3: [],
      file1: "",
      file2: "",
      file3: "",
      excelData1: [],
      excelData2: [],
      excelData3: [],
      errData1: [],
      errData2: [],
      errData3: [],
      showModal1: false,
      showModal2: false,
      showModal3: false,
      Mechanism1: [],
      Mechanism2: [],
      Mechanism3: [],
      arr: [],

      arr2: [],
      arr3: [],

      Target: [],
      Forecast: [],
      Actual: [],
      salList: "",
      input: "",
      saleYear: "",
      selectedTerritory: "",
      page: this.GLOBAL.page_cz_sale,
    };
  },
  components: {
    pagination,
  },
  methods: {
    // fenye
    changePageClick(page, size) {
      if (page) {
        this.page.current = page;
      }
      if (size) {
        this.page.size = size;
      }
      // console.log(this.page)
      this.init();
      this.getSalesById();
    },

    mystyle(obj) {
      let month1 = parseInt(new Date().getMonth()) + 1;
      let a = parseInt(obj.column.label);
      if (a == month1) {
        return {
          color: "#ff9901",
        };
      }
    },
    SumSuanFa(m, z) {
      if (z == 0) {
        return "--";
      } else if (isNaN(m)) {
        return "--";
      } else {
        return m;
      }
    },
    async getParsingFile(fileName) {
      return new Promise(function(resolve, reject) {
        //定义reader，存放文件读取方法
        let reader = new FileReader();
        //启动函数
        reader.readAsBinaryString(fileName);
        //onload文件读取成功
        reader.onload = function(e) {
          //workbook存放excel的所有基本信息
          let workbook = xlsx.read(e.target.result, { type: "binary" });
          xlsx.onprogress = function(e) {};
          //定义sheetList中存放excel表格的sheet表，就是最下方的tab
          let sheetList = workbook.SheetNames;

          //存放json数组格式的表格数据
          let resultJson = [];
          if (sheetList.length > 1) {
            reject({ status: false, message: "模板错误,不能有1个以上sheet" });
          }
          sheetList.forEach(function(y) {
            let worksheet = workbook.Sheets[y];
            resultJson = xlsx.utils.sheet_to_json(workbook.Sheets[y], {
              defval: "",
            });
          });

          if (resultJson.length === 0) {
            resolve({ status: true, data: resultJson });
          }
          //取出表头
          let tableHeader = Object.keys(resultJson[0]);

          //取出表数据
          let importInfo = resultJson.map((item) => {
            return tableHeader.map((v) => item[v]);
          });

          importInfo = [tableHeader, ...importInfo];
          resolve({ status: true, data: importInfo });
        };

        //文件读取失败
        reader.onerror = function(e) {
          reject({ status: false, message: "解析失败" });
        };
      });
    },
    async handleChange1(file, fileList, name) {
      this.loading = true;
      this.$refs.upload1.clearFiles();
      this.loadingText = "文件解析中";
      let res = await this.getParsingFile(file.raw);

      setTimeout(() => {
        this.loading = false;
        this.loadingText = "拼命加载中";
      }, 1000);
      if (!res.status) {
        this.$message.error(res.message);
        this.fileList1 = [];
        return;
      }

      if (
        res.data.length === 0 ||
        res.data[0].length !== 7 ||
        res.data[0][0].trim() !== "月份" ||
        res.data[0][1].trim() !== name + "编码" ||
        !res.data[0][6].trim().includes("指标")
      ) {
        this.$message.error("模板错误，请选择正确的模板");
        this.fileList1 = [];
        return false;
      }
      if (res.data.slice(1).length === 0) {
        this.$message.error("导入数据必须大于0条");
        this.fileList1 = [];
        return false;
      }
      if (fileList.length !== 0 && res) {
        this.file1 = file.name;
      }
      this.excelData1 = res.data;
    },
    async handleChange2(file, fileList, name) {
      this.loading = true;
      this.$refs.upload2.clearFiles();
      this.loadingText = "文件解析中";
      let res = await this.getParsingFile(file.raw);

      setTimeout(() => {
        this.loading = false;
        this.loadingText = "拼命加载中";
      }, 1000);
      if (!res.status) {
        this.$message.error(res.message);
        this.fileList2 = [];
        return;
      }

      if (
        res.data.length === 0 ||
        res.data[0].length !== 7 ||
        res.data[0][0].trim() !== "月份" ||
        res.data[0][1].trim() !== name + "编码" ||
        !res.data[0][6].trim().includes("预估")
      ) {
        this.$message.error("模板错误，请选择正确的模板");
        this.fileList2 = [];
        return false;
      }
      if (res.data.slice(1).length === 0) {
        this.$message.error("导入数据必须大于0条");
        this.fileList2 = [];
        return false;
      }
      if (fileList.length !== 0 && res) {
        this.file2 = file.name;
      }
      this.excelData2 = res.data;
    },
    async handleChange3(file, fileList, name) {
      this.loading = true;
      this.$refs.upload3.clearFiles();
      this.loadingText = "文件解析中";
      let res = await this.getParsingFile(file.raw);

      setTimeout(() => {
        this.loading = false;
        this.loadingText = "拼命加载中";
      }, 1000);
      if (!res.status) {
        this.$message.error(res.message);
        this.fileList3 = [];
        return;
      }

      if (
        res.data.length === 0 ||
        res.data[0].length !== 7 ||
        res.data[0][0].trim() !== "月份" ||
        res.data[0][1].trim() !== name + "编码" ||
        !res.data[0][6].trim().includes("销量")
      ) {
        this.$message.error("模板错误，请选择正确的模板");
        this.fileList3 = [];
        return false;
      }
      if (res.data.slice(1).length === 0) {
        this.$message.error("导入数据必须大于0条");
        this.fileList3 = [];
        return false;
      }
      if (fileList.length !== 0 && res) {
        this.file3 = file.name;
      }
      this.excelData3 = res.data;
    },

    async imortDataClick1(type) {
      if (this.excelData1.length === 0) {
        this.$message.error("请选择导入模板！");
        return false;
      }
      this.loading = true;
      this.loadingText = `正在导入数据0%(0/${this.excelData1.length - 1})`;
      this.errData1 = "";
      this.record = [];
      let herder = this.excelData1[0];
      let res = await this.importData1(herder, this.excelData1.slice(1), 0, 500, this.excelData1.length - 1, type);

      if (!res) {
        this.$message.error("导入失败");
        this.loading = false;
        this.loadingText = "拼命加载中";
      } else {
        if (this.record.some((item) => item)) {
          this.$message.success("导入成功");
          this.loadingText = "拼命加载中";
          this.loading = false;
          if (this.errData1.length > 0) {
            this.showModal1 = true;
            this.Mechanism1 = this.errData1.slice(0, 100);
          }
        } else {
          this.$message.error("导入失败");
          this.loading = false;
          this.loadingText = "拼命加载中";
        }
      }
    },
    async importData1(herder, excelData = [], page = 0, limit = 1000, size = 0, type) {
      try {
        if (page * limit >= size) {
          return true;
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          type: type,
          data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
        };

        let response = await http.post("/wapi/excel/imortTarget", data);

        if (!response) {
          return false;
        }
        if (response.statusCode === 502) {
          return await this.importData1(herder, excelData, page, limit, size, type);
        }
        this.loadingText = "正在导入数据" + (((page + 1) * limit) / size > 1 ? "100%" : ((((page + 1) * limit) / size) * 100).toFixed(0) + "% ");
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`;
        this.loadingText += progressText;

        if (response.success) {
          this.record.push(true);
          if (response.data) {
            if (!this.errData1) {
              this.errData1 = [];
            }
            this.errData1 = [...this.errData1, ...response.data];
          }
        } else {
          this.record.push(false);
        }
        return await this.importData1(herder, excelData, page + 1, limit, size, type);
      } catch (e) {
        return false;
      }
    },

    async imortDataClick2(type) {
      if (this.excelData2.length === 0) {
        this.$message.error("请选择导入模板！");
        return false;
      }
      this.loading = true;
      this.loadingText = `正在导入数据0%(0/${this.excelData2.length - 1})`;
      this.errData2 = "";
      this.record = [];
      let herder = this.excelData2[0];
      let res = await this.importData2(herder, this.excelData2.slice(1), 0, 500, this.excelData2.length - 1, type);

      if (!res) {
        this.$message.error("导入失败");
        this.loading = false;
        this.loadingText = "拼命加载中";
      } else {
        if (this.record.some((item) => item)) {
          this.$message.success("导入成功");
          this.loadingText = "拼命加载中";
          this.loading = false;
          if (this.errData2.length > 0) {
            this.showModal2 = true;
            this.Mechanism2 = this.errData2.slice(0, 100);
          }
        } else {
          this.$message.error("导入失败");
          this.loading = false;
          this.loadingText = "拼命加载中";
        }
      }
    },
    async importData2(herder, excelData = [], page = 0, limit = 1000, size = 0, type) {
      try {
        if (page * limit >= size) {
          return true;
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          type: type,
          data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
        };

        let response = await http.post("/wapi/excel/imortForecast", data);

        if (!response) {
          return false;
        }
        if (response.statusCode === 502) {
          return await this.importData2(herder, excelData, page, limit, size, type);
        }
        this.loadingText = "正在导入数据" + (((page + 1) * limit) / size > 1 ? "100%" : ((((page + 1) * limit) / size) * 100).toFixed(0) + "% ");
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`;
        this.loadingText += progressText;

        if (response.success) {
          this.record.push(true);
          if (response.data) {
            if (!this.errData2) {
              this.errData2 = [];
            }
            this.errData2 = [...this.errData2, ...response.data];
          }
        } else {
          this.record.push(false);
        }
        return await this.importData2(herder, excelData, page + 1, limit, size, type);
      } catch (e) {
        return false;
      }
    },

    async imortDataClick3(type) {
      if (this.excelData3.length === 0) {
        this.$message.error("请选择导入模板！");
        return false;
      }
      this.loading = true;
      this.loadingText = `正在导入数据0%(0/${this.excelData3.length - 1})`;
      this.errData3 = "";
      this.record = [];
      let herder = this.excelData3[0];
      let res = await this.importData3(herder, this.excelData3.slice(1), 0, 500, this.excelData3.length - 1, type);

      if (!res) {
        this.$message.error("导入失败");
        this.loading = false;
        this.loadingText = "拼命加载中";
      } else {
        if (this.record.some((item) => item)) {
          this.$message.success("导入成功");
          this.loadingText = "拼命加载中";
          this.loading = false;
          if (this.errData3.length > 0) {
            this.showModal3 = true;
            this.Mechanism3 = this.errData3.slice(0, 100);
          }
        } else {
          this.$message.error("导入失败");
          this.loading = false;
          this.loadingText = "拼命加载中";
        }
      }
    },
    async importData3(herder, excelData = [], page = 0, limit = 1000, size = 0, type) {
      try {
        if (page * limit >= size) {
          return true;
        }
        let data = {
          progressNum: page * limit,
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          type: type,
          data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
        };

        let response = await http.post("/wapi/excel/imortActual", data);

        if (!response) {
          return false;
        }
        if (response.statusCode === 502) {
          return await this.importData3(herder, excelData, page, limit, size, type);
        }
        this.loadingText = "正在导入数据" + (((page + 1) * limit) / size > 1 ? "100%" : ((((page + 1) * limit) / size) * 100).toFixed(0) + "% ");
        let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`;
        this.loadingText += progressText;

        if (response.success) {
          this.record.push(true);
          if (response.data) {
            if (!this.errData3) {
              this.errData3 = [];
            }
            this.errData3 = [...this.errData3, ...response.data];
          }
        } else {
          this.record.push(false);
        }
        return await this.importData3(herder, excelData, page + 1, limit, size, type);
      } catch (e) {
        return false;
      }
    },
    //导出数据
    async xiazai(type) {
      this.loading = true;
      this.loadingText = "正在下载中";
      let params = {
        user_id: this.$store.getters.getUser.user_id,
        tenant_id: this.$store.getters.getUser.tenant_id,
        type: type,
        month: "",
        tableType: this.activeNameImp,
      };
      let fileName = "";
      if (this.activeNameImp === "institution") {
        fileName = "机构";
      } else if (this.activeNameImp === "retailstore") {
        fileName = "门店";
      } else if (this.activeNameImp === "distributor") {
        fileName = "经销商";
      }
      if (type === "指标") {
        fileName += "销售指标" + this.download.month1;
        params.month = this.download.month1;
      } else if (type === "预估") {
        fileName += "销量预估" + this.download.month2;
        params.month = this.download.month2;
      } else if (type === "销量") {
        fileName += "实际销量" + this.download.month3;
        params.month = this.download.month3;
      }

      await axios({
        method: "post",
        url: "/wapi/derive/exportSales",
        data: params,
        responseType: "arraybuffer",
        // responseType: "blob",
      })
        .then((res) => {
          // let uInt8Array = new Uint8Array(res.data); //先将返回的二进制数组转化为js的二进制数组
          // if (res.status !== 200) {
          //   this.loading = false;
          //   this.loadingText = "拼命加载中";
          //   this.$message.error("下载失败");
          //   return;
          // }
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
          const elink = document.createElement("a");
          elink.download = fileName + ".xlsx";
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          this.loading = false;
          this.loadingText = "拼命加载中";
        })
        .catch((e) => {
          this.loading = false;
          this.loadingText = "拼命加载中";
          this.$message.error("下载失败");
        });
    },
    handleExportData1() {
      try {
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "月份",
            `${this.dialogConfig[this.activeNameImp].name}编码`,
            `${this.dialogConfig[this.activeNameImp].name}名称`,
            "SKU编码",
            "SKU名称",
            "指标（数量）",
            "指标（金额）",
            "报错信息",
          ];
          const filterVal = ["month", "code", "name", "sku_code", "sku_name", "number", "amount", "message"];
          let arr = [...this.Mechanism1];

          const list = arr;
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "报错信息表",
            autoWidth: this.autoWidth,
          });
        });
        this.loading = false;
        this.showModal1 = false;
      } catch (err) {
        this.loading = false;
        this.error();
      }
    },
    handleExportData2() {
      try {
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "月份",
            `${this.dialogConfig[this.activeNameImp].name}编码`,
            `${this.dialogConfig[this.activeNameImp].name}名称`,
            "SKU编码",
            "SKU名称",
            "预估（数量）",
            "预估（金额）",
            "报错信息",
          ];
          const filterVal = ["month", "code", "name", "sku_code", "sku_name", "number", "amount", "message"];
          let arr = [...this.Mechanism2];

          const list = arr;
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "报错信息表",
            autoWidth: this.autoWidth,
          });
        });
        this.loading = false;
        this.showModal2 = false;
      } catch (err) {
        this.loading = false;
        this.error();
      }
    },
    handleExportData3() {
      try {
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "月份",
            `${this.dialogConfig[this.activeNameImp].name}编码`,
            `${this.dialogConfig[this.activeNameImp].name}名称`,
            "SKU编码",
            "SKU名称",
            "销量（数量）",
            "销量（金额）",
            "报错信息",
          ];
          const filterVal = ["month", "code", "name", "sku_code", "sku_name", "number", "amount", "message"];
          let arr = [...this.Mechanism3];

          const list = arr;
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "报错信息表",
            autoWidth: this.autoWidth,
          });
        });
        this.loading = false;
        this.showModal3 = false;
      } catch (err) {
        this.loading = false;
        this.error();
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //导入tabs切换
    tabsChange() {
      this.fileList1 = [];
      this.fileList2 = [];
      this.fileList3 = [];
      this.file1 = "";
      this.file2 = "";
      this.file3 = "";
      this.excelData1 = [];
      this.excelData2 = [];
      this.excelData3 = [];
      this.download.month1 = "";
      this.download.month2 = "";
      this.download.month3 = "";
    },
    //关闭导入弹框
    closeModal2() {
      this.fileList1 = [];
      this.fileList2 = [];
      this.fileList3 = [];
      this.file1 = "";
      this.file2 = "";
      this.file3 = "";
      this.excelData1 = [];
      this.excelData2 = [];
      this.excelData3 = [];
      this.dialogVisible2 = false;
      this.download.month1 = "";
      this.download.month2 = "";
      this.download.month3 = "";
    },
    dianji() {
      this.dialogVisible2 = true;
    },
    jump() {
      this.$router.push({ path: "/into" });
    },
    baocun() {
      this.saveSalesByEndPoint();
      this.dialogVisible = false;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 4 === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 1) {
        if (rowIndex % 4 === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    bianji() {
      this.SalesListArray = [];
      this.dialogVisible = true;
      this.getEditSalesList();
    },
    fangfa(item) {
      if (item == "按产品") {
        this.key = "PRODUCT";
      } else if (item == "按客户") {
        this.key = "INSTITUTION";
      }
      this.getTerritoryListByEndPoint();
    },

    fangfa2(item) {
      if (item == "按产品") {
        this.key2 = "PRODUCT";
      } else if (item == "按客户") {
        this.key2 = "INSTITUTION";
      }
      this.getEditSalesList();
    },
    handleNodeExpand(a, b, c) {},

    loadNode(node, resolve) {
      this.getLoadNode(node, resolve);
    },
    async getLoadNode(node, resolve) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        month: new Date(),
        territory_id: node.data.territory_id,
      };

      if (node.level > 0) {
        await http.post("/wapi/sales/jurisdiction", data).then((res) => {
          for (let i = 0; i < res.length; i++) {
            if (res[i].territory_type === "ENDPOINT") {
              res[i].leaf = true;
            }
          }
          resolve(res);
          for (let i = 0; i < res.length; i++) {
            if (this.nodeData.data.territory_id === res[i].territory_id) {
              this.nodeData.data = res[i];
              this.territory_name = this.nodeData.data.territory_name;
            }
          }
        });
      }
    },

    async getSalesById() {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {};
        data.user_id = this.$store.getters.getUser.user_id;
        data.tenant_id = this.$store.getters.getUser.tenant_id;
        data.saleYear = this.saleYear;
        data.offset = this.page.current - 1;
        data.territory_id = this.sonNodeKey;
        data.limit = this.page.size;
        data.owner_id = "";
        data.month = moment().format("YYYYMM");

        await http.post("/crm/activity/sales/getSalesById", data).then((res) => {
          if (res.success == true) {
            this.page.total = res.data.tatalNum;
            this.tableData1 = res.data.arr;
            loading.close();
          } else {
            loading.close();
          }
        });
      } catch (e) {
        loading.close();
      }
    },

    handleNodeClick(data, node, ele) {
      this.parentNodeKey = node.parent.data.territory_id;
      this.sonNodeKey = node.data.territory_id;
      this.nodeData = node;
      this.tableData = [];
      this.territory_name = data.territory_name;
      this.territory_level_name = data.territory_level_name;
      console.log(this.sonNodeKey);
      this.getSalesById();
      if (data.territory_type === "CONTAINER") {
        this.territory_region = "地区";
        this.getTerritoryListByContainer();
        this.terminal = false;
      } else {
        if (this.radio1 == "按产品") {
          this.key = "PRODUCT";
        } else if (this.radio1 == "按客户") {
          this.key = "INSTITUTION";
        }
        this.getTerritoryListByEndPoint();
        this.terminal = true;
        this.territory_region = "终端";
      }
      this.territory_code = data.territory_code;
      this.owner_name = data.owner_name;
      this.owner_title = data.title;
      this.salList = data.isManage;
    },
    //
    async init() {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {};
        data.tenant_id = this.$store.getters.getUser.tenant_id;
        data.user_id = this.$store.getters.getUser.user_id;
        data.month = new Date();
        await http.post("/wapi/sales/jurisdiction", data).then((res) => {
          if (res.length > 0) {
            let array = res;
            this.folderArry = array;
            debugger;
            this.$nextTick().then(() => {
              const firstNode = document.querySelector(".el-tree-node");
              firstNode.click();
            });
            loading.close();
          } else {
            loading.close();
          }
        });
      } catch (e) {
        loading.close();
      }
    },

    async getTerritoryListByContainer() {
      let self = this;
      self.loading = true;
      let data = {
        user_id: this.$store.getters.getUser.user_id,
        tenant_id: this.$store.getters.getUser.tenant_id,
        territory_type: "CONTAINER",
        territory_id: this.sonNodeKey,
        saleYear: this.saleYear,
      };
      self.skuArray = [];
      self.tableData = [];
      await http.post("/wapi/sales/getTerritoryListByContainer", data).then((res) => {
        if (res.success) {
          self.productCount = res.data.productCount;
          self.endPoint = res.data.endPoint;
          self.salesTeam = res.data.salesTeam;
          self.ContainerArray = res.data.array;
          self.skuArray = res.data.skuArray;
          if (self.skuArray.length > 0) {
            self.activeName = self.skuArray[0].sku_id;
            // for (let i = 0; i < self.ContainerArray.length; i++) {
            let item = self.ContainerArray[0];
            self.skuArray[0]["tableData"] = [];
            //                                let obj1 = {
            //                                    m1_target_quantity: "",
            //                                    m1_forecast_quantity:'',
            //                                    m1_actual_quantity:''
            //                                }
            //                                obj1.m1_target_quantity=item.m1_target_quantity
            //                                obj1.m1_forecast_quantity=item.m1_forecast_quantity
            //                                obj1.m1_actual_quantity=item.m1_actual_quantity

            let target = {
              title: "指标",
              m1: item.m1_target_quantity == null ? "-" : item.m1_target_quantity,
              m2: item.m2_target_quantity == null ? "-" : item.m2_target_quantity,
              m3: item.m3_target_quantity == null ? "-" : item.m3_target_quantity,
              m4: item.m4_target_quantity == null ? "-" : item.m4_target_quantity,
              m5: item.m5_target_quantity == null ? "-" : item.m5_target_quantity,
              m6: item.m6_target_quantity == null ? "-" : item.m6_target_quantity,
              m7: item.m7_target_quantity == null ? "-" : item.m7_target_quantity,
              m8: item.m8_target_quantity == null ? "-" : item.m8_target_quantity,
              m9: item.m9_target_quantity == null ? "-" : item.m9_target_quantity,
              m10: item.m10_target_quantity == null ? "-" : item.m10_target_quantity,
              m11: item.m11_target_quantity == null ? "-" : item.m11_target_quantity,
              m12: item.m12_target_quantity == null ? "-" : item.m12_target_quantity,
            };
            let forecast = {
              title: "预估",
              m1: item.m1_forecast_quantity == null ? "-" : item.m1_forecast_quantity,
              m2: item.m2_forecast_quantity == null ? "-" : item.m2_forecast_quantity,
              m3: item.m3_forecast_quantity == null ? "-" : item.m3_forecast_quantity,
              m4: item.m4_forecast_quantity == null ? "-" : item.m4_forecast_quantity,
              m5: item.m5_forecast_quantity == null ? "-" : item.m5_forecast_quantity,
              m6: item.m6_forecast_quantity == null ? "-" : item.m6_forecast_quantity,
              m7: item.m7_forecast_quantity == null ? "-" : item.m7_forecast_quantity,
              m8: item.m8_forecast_quantity == null ? "-" : item.m8_forecast_quantity,
              m9: item.m9_forecast_quantity == null ? "-" : item.m9_forecast_quantity,
              m10: item.m10_forecast_quantity == null ? "-" : item.m10_forecast_quantity,
              m11: item.m11_forecast_quantity == null ? "-" : item.m11_forecast_quantity,
              m12: item.m12_forecast_quantity == null ? "-" : item.m12_forecast_quantity,
            };
            let actual = {
              title: "实际",
              m1: item.m1_actual_quantity == null ? "-" : item.m1_actual_quantity,
              m2: item.m2_actual_quantity == null ? "-" : item.m2_actual_quantity,
              m3: item.m3_actual_quantity == null ? "-" : item.m3_actual_quantity,
              m4: item.m4_actual_quantity == null ? "-" : item.m4_actual_quantity,
              m5: item.m5_actual_quantity == null ? "-" : item.m5_actual_quantity,
              m6: item.m6_actual_quantity == null ? "-" : item.m6_actual_quantity,
              m7: item.m7_actual_quantity == null ? "-" : item.m7_actual_quantity,
              m8: item.m8_actual_quantity == null ? "-" : item.m8_actual_quantity,
              m9: item.m9_actual_quantity == null ? "-" : item.m9_actual_quantity,
              m10: item.m10_actual_quantity == null ? "-" : item.m10_actual_quantity,
              m11: item.m11_actual_quantity == null ? "-" : item.m11_actual_quantity,
              m12: item.m12_actual_quantity == null ? "-" : item.m12_actual_quantity,
            };
            let dcl = {
              title: "达成率",
              m1: this.SumSuanFa(((item.m1_actual_quantity / item.m1_target_quantity) * 100).toFixed(1)) + "%",
              m2: this.SumSuanFa(((item.m2_actual_quantity / item.m2_target_quantity) * 100).toFixed(1)) + "%",
              m3: this.SumSuanFa(((item.m3_actual_quantity / item.m3_target_quantity) * 100).toFixed(1)) + "%",
              m4: this.SumSuanFa(((item.m4_actual_quantity / item.m4_target_quantity) * 100).toFixed(1)) + "%",
              m5: this.SumSuanFa(((item.m5_actual_quantity / item.m5_target_quantity) * 100).toFixed(1)) + "%",
              m6: this.SumSuanFa(((item.m6_actual_quantity / item.m6_target_quantity) * 100).toFixed(1)) + "%",
              m7: this.SumSuanFa(((item.m7_actual_quantity / item.m7_target_quantity) * 100).toFixed(1)) + "%",
              m8: this.SumSuanFa(((item.m8_actual_quantity / item.m8_target_quantity) * 100).toFixed(1)) + "%",
              m9: this.SumSuanFa(((item.m9_actual_quantity / item.m9_target_quantity) * 100).toFixed(1)) + "%",
              m10: this.SumSuanFa(((item.m10_actual_quantity / item.m10_target_quantity) * 100).toFixed(1)) + "%",
              m11: this.SumSuanFa(((item.m11_actual_quantity / item.m11_target_quantity) * 100).toFixed(1)) + "%",
              m12: this.SumSuanFa(((item.m12_actual_quantity / item.m12_target_quantity) * 100).toFixed(1)) + "%",
            };

            self.tableData.push(target);
            self.tableData.push(forecast);
            self.tableData.push(actual);
            self.tableData.push(dcl);
            // }
          }

          self.loading = false;
        } else {
          Message.error(res.message);
        }
        self.loading = false;
      });
    },
    async getSkuSalesData(tab, event) {
      try {
        let self = this;
        let obj = self.skuArray[tab.index];
        self.tableData = [];
        self.loading = true;
        let data = {
          skuObj: obj,
          tenant_id: this.$store.getters.getUser.tenant_id,
          territory_id: this.sonNodeKey,
          territory_type: "CONTAINER",
          saleYear: this.saleYear,
        };
        await http.post("/wapi/sales/getSkuSalesData", data).then((res) => {
          if (res.success) {
            let item = res.data[0];
            let target = {
              title: "指标",
              m1: item.m1_target_quantity == null ? "-" : item.m1_target_quantity,
              m2: item.m2_target_quantity == null ? "-" : item.m2_target_quantity,
              m3: item.m3_target_quantity == null ? "-" : item.m3_target_quantity,
              m4: item.m4_target_quantity == null ? "-" : item.m4_target_quantity,
              m5: item.m5_target_quantity == null ? "-" : item.m5_target_quantity,
              m6: item.m6_target_quantity == null ? "-" : item.m6_target_quantity,
              m7: item.m7_target_quantity == null ? "-" : item.m7_target_quantity,
              m8: item.m8_target_quantity == null ? "-" : item.m8_target_quantity,
              m9: item.m9_target_quantity == null ? "-" : item.m9_target_quantity,
              m10: item.m10_target_quantity == null ? "-" : item.m10_target_quantity,
              m11: item.m11_target_quantity == null ? "-" : item.m11_target_quantity,
              m12: item.m12_target_quantity == null ? "-" : item.m12_target_quantity,
            };
            let forecast = {
              title: "预估",
              m1: item.m1_forecast_quantity == null ? "-" : item.m1_forecast_quantity,
              m2: item.m2_forecast_quantity == null ? "-" : item.m2_forecast_quantity,
              m3: item.m3_forecast_quantity == null ? "-" : item.m3_forecast_quantity,
              m4: item.m4_forecast_quantity == null ? "-" : item.m4_forecast_quantity,
              m5: item.m5_forecast_quantity == null ? "-" : item.m5_forecast_quantity,
              m6: item.m6_forecast_quantity == null ? "-" : item.m6_forecast_quantity,
              m7: item.m7_forecast_quantity == null ? "-" : item.m7_forecast_quantity,
              m8: item.m8_forecast_quantity == null ? "-" : item.m8_forecast_quantity,
              m9: item.m9_forecast_quantity == null ? "-" : item.m9_forecast_quantity,
              m10: item.m10_forecast_quantity == null ? "-" : item.m10_forecast_quantity,
              m11: item.m11_forecast_quantity == null ? "-" : item.m11_forecast_quantity,
              m12: item.m12_forecast_quantity == null ? "-" : item.m12_forecast_quantity,
            };
            let actual = {
              title: "实际",
              m1: item.m1_actual_quantity == null ? "-" : item.m1_actual_quantity,
              m2: item.m2_actual_quantity == null ? "-" : item.m2_actual_quantity,
              m3: item.m3_actual_quantity == null ? "-" : item.m3_actual_quantity,
              m4: item.m4_actual_quantity == null ? "-" : item.m4_actual_quantity,
              m5: item.m5_actual_quantity == null ? "-" : item.m5_actual_quantity,
              m6: item.m6_actual_quantity == null ? "-" : item.m6_actual_quantity,
              m7: item.m7_actual_quantity == null ? "-" : item.m7_actual_quantity,
              m8: item.m8_actual_quantity == null ? "-" : item.m8_actual_quantity,
              m9: item.m9_actual_quantity == null ? "-" : item.m9_actual_quantity,
              m10: item.m10_actual_quantity == null ? "-" : item.m10_actual_quantity,
              m11: item.m11_actual_quantity == null ? "-" : item.m11_actual_quantity,
              m12: item.m12_actual_quantity == null ? "-" : item.m12_actual_quantity,
            };
            let dcl = {
              title: "达成率",
              m1: this.SumSuanFa(((item.m1_actual_quantity / item.m1_target_quantity) * 100).toFixed(1)) + "%",
              m2: this.SumSuanFa(((item.m2_actual_quantity / item.m2_target_quantity) * 100).toFixed(1)) + "%",
              m3: this.SumSuanFa(((item.m3_actual_quantity / item.m3_target_quantity) * 100).toFixed(1)) + "%",
              m4: this.SumSuanFa(((item.m4_actual_quantity / item.m4_target_quantity) * 100).toFixed(1)) + "%",
              m5: this.SumSuanFa(((item.m5_actual_quantity / item.m5_target_quantity) * 100).toFixed(1)) + "%",
              m6: this.SumSuanFa(((item.m6_actual_quantity / item.m6_target_quantity) * 100).toFixed(1)) + "%",
              m7: this.SumSuanFa(((item.m7_actual_quantity / item.m7_target_quantity) * 100).toFixed(1)) + "%",
              m8: this.SumSuanFa(((item.m8_actual_quantity / item.m8_target_quantity) * 100).toFixed(1)) + "%",
              m9: this.SumSuanFa(((item.m9_actual_quantity / item.m9_target_quantity) * 100).toFixed(1)) + "%",
              m10: this.SumSuanFa(((item.m10_actual_quantity / item.m10_target_quantity) * 100).toFixed(1)) + "%",
              m11: this.SumSuanFa(((item.m11_actual_quantity / item.m11_target_quantity) * 100).toFixed(1)) + "%",
              m12: this.SumSuanFa(((item.m12_actual_quantity / item.m12_target_quantity) * 100).toFixed(1)) + "%",
            };

            self.tableData.push(target);
            self.tableData.push(forecast);
            self.tableData.push(actual);
            self.tableData.push(dcl);
            self.loading = false;
          }
        });
      } catch (e) {}
    },

    async getTerritoryListByEndPoint() {
      let self = this;
      try {
        self.loading = true;
        let data = {
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          territory_id: this.sonNodeKey,
          territory_type: "ENDPOINT",
          saleYear: this.saleYear,
          data_type: this.key,
        };
        self.skuArray = [];
        self.allArray = [];
        await http.post("/wapi/sales/getTerritoryListByEndPoint", data).then((res) => {
          if (res.success) {
            this.productCount = res.data.productCount;
            this.institutionCount = res.data.institutionCount;
            this.storeCount = res.data.storeCount;
            this.distributorCount = res.data.distributorCount;
            this.institutionsArray = res.data.array;
            this.allArray = res.data.allArray;
            this.skuArray = res.data.skuArray;

            // let arr=res.data.array
            //                             arr.map(item=>{
            //
            //                                 let obj={
            //                                     sku_id:item.sku_id,
            //                                     sku_name:item.sku_name,
            //                                     id:item.id,
            //                                     name:item.name,
            //                                 }
            //                                 return obj
            //                             })
            //                             let result=[]
            //                             let myobj={}
            //                             for(let i=0;i<arr.length;i++){
            //                                 if(!myobj[arr[i][this.key!='INSTITUTION'?'sku_id':'id']]){
            //                                     result.push(arr[i])
            //                                     myobj[arr[i][ this.key!='INSTITUTION'?'sku_id':'id']]=true
            //                                 }
            //                             }

            //
            // for(let j=0;j<result.length;j++){
            //     let arr=[]
            for (let i = 0; i < this.institutionsArray.length; i++) {
              let item = this.institutionsArray[i];

              // if(result[j][ this.key!='INSTITUTION'?'sku_id':'id']==item[ this.key!='INSTITUTION'?'sku_id':'id']){
              item.tableData2 = [];
              let target = {
                title: "指标",
                name: item.sku_name,
                type: item.type,
                key_id: item.key_id,
                m1: item.m1_target_quantity == null ? "-" : item.m1_target_quantity,
                m2: item.m2_target_quantity == null ? "-" : item.m2_target_quantity,
                m3: item.m3_target_quantity == null ? "-" : item.m3_target_quantity,
                m4: item.m4_target_quantity == null ? "-" : item.m4_target_quantity,
                m5: item.m5_target_quantity == null ? "-" : item.m5_target_quantity,
                m6: item.m6_target_quantity == null ? "-" : item.m6_target_quantity,
                m7: item.m7_target_quantity == null ? "-" : item.m7_target_quantity,
                m8: item.m8_target_quantity == null ? "-" : item.m8_target_quantity,
                m9: item.m9_target_quantity == null ? "-" : item.m9_target_quantity,
                m10: item.m10_target_quantity == null ? "-" : item.m10_target_quantity,
                m11: item.m11_target_quantity == null ? "-" : item.m11_target_quantity,
                m12: item.m12_target_quantity == null ? "-" : item.m12_target_quantity,
              };
              let forecast = {
                title: "预估",
                name: item.name,
                type: item.type,
                key_id: item.key_id,
                m1: item.m1_forecast_quantity == null ? "-" : item.m1_forecast_quantity,
                m2: item.m2_forecast_quantity == null ? "-" : item.m2_forecast_quantity,
                m3: item.m3_forecast_quantity == null ? "-" : item.m3_forecast_quantity,
                m4: item.m4_forecast_quantity == null ? "-" : item.m4_forecast_quantity,
                m5: item.m5_forecast_quantity == null ? "-" : item.m5_forecast_quantity,
                m6: item.m6_forecast_quantity == null ? "-" : item.m6_forecast_quantity,
                m7: item.m7_forecast_quantity == null ? "-" : item.m7_forecast_quantity,
                m8: item.m8_forecast_quantity == null ? "-" : item.m8_forecast_quantity,
                m9: item.m9_forecast_quantity == null ? "-" : item.m9_forecast_quantity,
                m10: item.m10_forecast_quantity == null ? "-" : item.m10_forecast_quantity,
                m11: item.m11_forecast_quantity == null ? "-" : item.m11_forecast_quantity,
                m12: item.m12_forecast_quantity == null ? "-" : item.m12_forecast_quantity,
              };
              let actual = {
                title: "实际",
                name: item.name,
                type: item.type,
                key_id: item.key_id,
                m1: item.m1_actual_quantity == null ? "-" : item.m1_actual_quantity,
                m2: item.m2_actual_quantity == null ? "-" : item.m2_actual_quantity,
                m3: item.m3_actual_quantity == null ? "-" : item.m3_actual_quantity,
                m4: item.m4_actual_quantity == null ? "-" : item.m4_actual_quantity,
                m5: item.m5_actual_quantity == null ? "-" : item.m5_actual_quantity,
                m6: item.m6_actual_quantity == null ? "-" : item.m6_actual_quantity,
                m7: item.m7_actual_quantity == null ? "-" : item.m7_actual_quantity,
                m8: item.m8_actual_quantity == null ? "-" : item.m8_actual_quantity,
                m9: item.m9_actual_quantity == null ? "-" : item.m9_actual_quantity,
                m10: item.m10_actual_quantity == null ? "-" : item.m10_actual_quantity,
                m11: item.m11_actual_quantity == null ? "-" : item.m11_actual_quantity,
                m12: item.m12_actual_quantity == null ? "-" : item.m12_actual_quantity,
              };
              let dcl = {
                title: "达成率",
                name: item.name,
                type: item.type,
                key_id: item.key_id,
                m1: this.SumSuanFa((item.m1_actual_quantity / item.m1_target_quantity) * 100, item.m1_target_quantity) + "%",
                m2: this.SumSuanFa((item.m2_actual_quantity / item.m2_target_quantity) * 100, item.m2_target_quantity) + "%",
                m3: this.SumSuanFa((item.m3_actual_quantity / item.m3_target_quantity) * 100, item.m3_target_quantity) + "%",
                m4: this.SumSuanFa((item.m4_actual_quantity / item.m4_target_quantity) * 100, item.m4_target_quantity) + "%",
                m5: this.SumSuanFa((item.m5_actual_quantity / item.m5_target_quantity) * 100, item.m5_target_quantity) + "%",
                m6: this.SumSuanFa((item.m6_actual_quantity / item.m6_target_quantity) * 100, item.m6_target_quantity) + "%",
                m7: this.SumSuanFa((item.m7_actual_quantity / item.m7_target_quantity) * 100, item.m7_target_quantity) + "%",
                m8: this.SumSuanFa((item.m8_actual_quantity / item.m8_target_quantity) * 100, item.m8_target_quantity) + "%",
                m9: this.SumSuanFa((item.m9_actual_quantity / item.m9_target_quantity) * 100, item.m9_target_quantity) + "%",
                m10: this.SumSuanFa((item.m10_actual_quantity / item.m10_target_quantity) * 100, item.m10_target_quantity) + "%",
                m11: this.SumSuanFa((item.m11_actual_quantity / item.m11_target_quantity) * 100, item.m11_target_quantity) + "%",
                m12: this.SumSuanFa((item.m12_actual_quantity / item.m12_target_quantity) * 100, item.m12_target_quantity) + "%",
              };
              item.tableData2.push(target);
              item.tableData2.push(forecast);
              item.tableData2.push(actual);
              item.tableData2.push(dcl);
              // arr.push(item)
            }

            // }
            // result[j].arr=arr
            // }
            // this.institutionsArray=result
            // this.activeName2=result[0][ this.key!='INSTITUTION'?'sku_id':'id']

            if (this.key === "PRODUCT") {
              for (let j = 0; j < this.skuArray.length; j++) {
                let obj = this.skuArray[j];
                obj.arr = [];
              }
              if (this.skuArray.length > 0) {
                this.activeName2 = this.skuArray[0].sku_id;
                this.skuArray[0].arr = this.institutionsArray;
              }
            }
            if (this.key === "INSTITUTION") {
              for (let j = 0; j < this.allArray.length; j++) {
                let obj = this.allArray[j];
                obj.arr = [];
              }
              if (this.allArray.length > 0) {
                this.allArray[0].arr = this.institutionsArray;
                this.activeName3 = this.allArray[0].institution_id || this.allArray[0].store_id || this.allArray[0].distributor_id;
              }
            }
          } else {
            Message.error(res.message);
          }
          self.loading = false;
        });
      } catch (e) {
        self.loading = false;
      }
    },
    async getEndTerritorySkuInfo(tab, event) {
      try {
        let self = this;
        let obj = self.skuArray[tab.index];
        self.loading = true;
        let data = {
          skuObj: obj,
          tenant_id: this.$store.getters.getUser.tenant_id,
          territory_id: this.sonNodeKey,
          saleYear: this.saleYear,
        };
        await http.post("/wapi/sales/getEndTerritorySkuInfo", data).then((res) => {
          if (res.success) {
            for (let i = 0; i < res.data.length; i++) {
              let item = res.data[i];
              item.tableData2 = [];
              let target = {
                title: "指标",
                name: item.sku_name,
                type: item.type,
                key_id: item.key_id,
                m1: item.m1_target_quantity == null ? "-" : item.m1_target_quantity,
                m2: item.m2_target_quantity == null ? "-" : item.m2_target_quantity,
                m3: item.m3_target_quantity == null ? "-" : item.m3_target_quantity,
                m4: item.m4_target_quantity == null ? "-" : item.m4_target_quantity,
                m5: item.m5_target_quantity == null ? "-" : item.m5_target_quantity,
                m6: item.m6_target_quantity == null ? "-" : item.m6_target_quantity,
                m7: item.m7_target_quantity == null ? "-" : item.m7_target_quantity,
                m8: item.m8_target_quantity == null ? "-" : item.m8_target_quantity,
                m9: item.m9_target_quantity == null ? "-" : item.m9_target_quantity,
                m10: item.m10_target_quantity == null ? "-" : item.m10_target_quantity,
                m11: item.m11_target_quantity == null ? "-" : item.m11_target_quantity,
                m12: item.m12_target_quantity == null ? "-" : item.m12_target_quantity,
              };
              let forecast = {
                title: "预估",
                name: item.name,
                type: item.type,
                key_id: item.key_id,
                m1: item.m1_forecast_quantity == null ? "-" : item.m1_forecast_quantity,
                m2: item.m2_forecast_quantity == null ? "-" : item.m2_forecast_quantity,
                m3: item.m3_forecast_quantity == null ? "-" : item.m3_forecast_quantity,
                m4: item.m4_forecast_quantity == null ? "-" : item.m4_forecast_quantity,
                m5: item.m5_forecast_quantity == null ? "-" : item.m5_forecast_quantity,
                m6: item.m6_forecast_quantity == null ? "-" : item.m6_forecast_quantity,
                m7: item.m7_forecast_quantity == null ? "-" : item.m7_forecast_quantity,
                m8: item.m8_forecast_quantity == null ? "-" : item.m8_forecast_quantity,
                m9: item.m9_forecast_quantity == null ? "-" : item.m9_forecast_quantity,
                m10: item.m10_forecast_quantity == null ? "-" : item.m10_forecast_quantity,
                m11: item.m11_forecast_quantity == null ? "-" : item.m11_forecast_quantity,
                m12: item.m12_forecast_quantity == null ? "-" : item.m12_forecast_quantity,
              };
              let actual = {
                title: "实际",
                name: item.name,
                type: item.type,
                key_id: item.key_id,
                m1: item.m1_actual_quantity == null ? "-" : item.m1_actual_quantity,
                m2: item.m2_actual_quantity == null ? "-" : item.m2_actual_quantity,
                m3: item.m3_actual_quantity == null ? "-" : item.m3_actual_quantity,
                m4: item.m4_actual_quantity == null ? "-" : item.m4_actual_quantity,
                m5: item.m5_actual_quantity == null ? "-" : item.m5_actual_quantity,
                m6: item.m6_actual_quantity == null ? "-" : item.m6_actual_quantity,
                m7: item.m7_actual_quantity == null ? "-" : item.m7_actual_quantity,
                m8: item.m8_actual_quantity == null ? "-" : item.m8_actual_quantity,
                m9: item.m9_actual_quantity == null ? "-" : item.m9_actual_quantity,
                m10: item.m10_actual_quantity == null ? "-" : item.m10_actual_quantity,
                m11: item.m11_actual_quantity == null ? "-" : item.m11_actual_quantity,
                m12: item.m12_actual_quantity == null ? "-" : item.m12_actual_quantity,
              };
              let dcl = {
                title: "达成率",
                name: item.name,
                type: item.type,
                key_id: item.key_id,
                m1: this.SumSuanFa((item.m1_actual_quantity / item.m1_target_quantity) * 100, item.m1_target_quantity) + "%",
                m2: this.SumSuanFa((item.m2_actual_quantity / item.m2_target_quantity) * 100, item.m2_target_quantity) + "%",
                m3: this.SumSuanFa((item.m3_actual_quantity / item.m3_target_quantity) * 100, item.m3_target_quantity) + "%",
                m4: this.SumSuanFa((item.m4_actual_quantity / item.m4_target_quantity) * 100, item.m4_target_quantity) + "%",
                m5: this.SumSuanFa((item.m5_actual_quantity / item.m5_target_quantity) * 100, item.m5_target_quantity) + "%",
                m6: this.SumSuanFa((item.m6_actual_quantity / item.m6_target_quantity) * 100, item.m6_target_quantity) + "%",
                m7: this.SumSuanFa((item.m7_actual_quantity / item.m7_target_quantity) * 100, item.m7_target_quantity) + "%",
                m8: this.SumSuanFa((item.m8_actual_quantity / item.m8_target_quantity) * 100, item.m8_target_quantity) + "%",
                m9: this.SumSuanFa((item.m9_actual_quantity / item.m9_target_quantity) * 100, item.m9_target_quantity) + "%",
                m10: this.SumSuanFa((item.m10_actual_quantity / item.m10_target_quantity) * 100, item.m10_target_quantity) + "%",
                m11: this.SumSuanFa((item.m11_actual_quantity / item.m11_target_quantity) * 100, item.m11_target_quantity) + "%",
                m12: this.SumSuanFa((item.m12_actual_quantity / item.m12_target_quantity) * 100, item.m12_target_quantity) + "%",
              };
              item.tableData2.push(target);
              item.tableData2.push(forecast);
              item.tableData2.push(actual);
              item.tableData2.push(dcl);
            }
            self.skuArray[tab.index].arr = res.data;
            this.$forceUpdate();
            self.loading = false;
          }
        });
      } catch (e) {}
    },
    async getEndTerritoryClientInfo(tab, event) {
      try {
        let self = this;
        let obj = self.allArray[tab.index];
        self.loading = true;
        let data = {
          clientObj: obj,
          tenant_id: this.$store.getters.getUser.tenant_id,
          territory_id: this.sonNodeKey,
          saleYear: this.saleYear,
        };
        await http.post("/wapi/sales/getEndTerritoryClientInfo", data).then((res) => {
          if (res.success) {
            for (let i = 0; i < res.data.length; i++) {
              let item = res.data[i];
              item.tableData2 = [];
              let target = {
                title: "指标",
                name: item.sku_name,
                type: item.type,
                key_id: item.key_id,
                m1: item.m1_target_quantity == null ? "-" : item.m1_target_quantity,
                m2: item.m2_target_quantity == null ? "-" : item.m2_target_quantity,
                m3: item.m3_target_quantity == null ? "-" : item.m3_target_quantity,
                m4: item.m4_target_quantity == null ? "-" : item.m4_target_quantity,
                m5: item.m5_target_quantity == null ? "-" : item.m5_target_quantity,
                m6: item.m6_target_quantity == null ? "-" : item.m6_target_quantity,
                m7: item.m7_target_quantity == null ? "-" : item.m7_target_quantity,
                m8: item.m8_target_quantity == null ? "-" : item.m8_target_quantity,
                m9: item.m9_target_quantity == null ? "-" : item.m9_target_quantity,
                m10: item.m10_target_quantity == null ? "-" : item.m10_target_quantity,
                m11: item.m11_target_quantity == null ? "-" : item.m11_target_quantity,
                m12: item.m12_target_quantity == null ? "-" : item.m12_target_quantity,
              };
              let forecast = {
                title: "预估",
                name: item.name,
                type: item.type,
                key_id: item.key_id,
                m1: item.m1_forecast_quantity == null ? "-" : item.m1_forecast_quantity,
                m2: item.m2_forecast_quantity == null ? "-" : item.m2_forecast_quantity,
                m3: item.m3_forecast_quantity == null ? "-" : item.m3_forecast_quantity,
                m4: item.m4_forecast_quantity == null ? "-" : item.m4_forecast_quantity,
                m5: item.m5_forecast_quantity == null ? "-" : item.m5_forecast_quantity,
                m6: item.m6_forecast_quantity == null ? "-" : item.m6_forecast_quantity,
                m7: item.m7_forecast_quantity == null ? "-" : item.m7_forecast_quantity,
                m8: item.m8_forecast_quantity == null ? "-" : item.m8_forecast_quantity,
                m9: item.m9_forecast_quantity == null ? "-" : item.m9_forecast_quantity,
                m10: item.m10_forecast_quantity == null ? "-" : item.m10_forecast_quantity,
                m11: item.m11_forecast_quantity == null ? "-" : item.m11_forecast_quantity,
                m12: item.m12_forecast_quantity == null ? "-" : item.m12_forecast_quantity,
              };
              let actual = {
                title: "实际",
                name: item.name,
                type: item.type,
                key_id: item.key_id,
                m1: item.m1_actual_quantity == null ? "-" : item.m1_actual_quantity,
                m2: item.m2_actual_quantity == null ? "-" : item.m2_actual_quantity,
                m3: item.m3_actual_quantity == null ? "-" : item.m3_actual_quantity,
                m4: item.m4_actual_quantity == null ? "-" : item.m4_actual_quantity,
                m5: item.m5_actual_quantity == null ? "-" : item.m5_actual_quantity,
                m6: item.m6_actual_quantity == null ? "-" : item.m6_actual_quantity,
                m7: item.m7_actual_quantity == null ? "-" : item.m7_actual_quantity,
                m8: item.m8_actual_quantity == null ? "-" : item.m8_actual_quantity,
                m9: item.m9_actual_quantity == null ? "-" : item.m9_actual_quantity,
                m10: item.m10_actual_quantity == null ? "-" : item.m10_actual_quantity,
                m11: item.m11_actual_quantity == null ? "-" : item.m11_actual_quantity,
                m12: item.m12_actual_quantity == null ? "-" : item.m12_actual_quantity,
              };
              let dcl = {
                title: "达成率",
                name: item.name,
                type: item.type,
                key_id: item.key_id,
                m1: this.SumSuanFa((item.m1_actual_quantity / item.m1_target_quantity) * 100, item.m1_target_quantity) + "%",
                m2: this.SumSuanFa((item.m2_actual_quantity / item.m2_target_quantity) * 100, item.m2_target_quantity) + "%",
                m3: this.SumSuanFa((item.m3_actual_quantity / item.m3_target_quantity) * 100, item.m3_target_quantity) + "%",
                m4: this.SumSuanFa((item.m4_actual_quantity / item.m4_target_quantity) * 100, item.m4_target_quantity) + "%",
                m5: this.SumSuanFa((item.m5_actual_quantity / item.m5_target_quantity) * 100, item.m5_target_quantity) + "%",
                m6: this.SumSuanFa((item.m6_actual_quantity / item.m6_target_quantity) * 100, item.m6_target_quantity) + "%",
                m7: this.SumSuanFa((item.m7_actual_quantity / item.m7_target_quantity) * 100, item.m7_target_quantity) + "%",
                m8: this.SumSuanFa((item.m8_actual_quantity / item.m8_target_quantity) * 100, item.m8_target_quantity) + "%",
                m9: this.SumSuanFa((item.m9_actual_quantity / item.m9_target_quantity) * 100, item.m9_target_quantity) + "%",
                m10: this.SumSuanFa((item.m10_actual_quantity / item.m10_target_quantity) * 100, item.m10_target_quantity) + "%",
                m11: this.SumSuanFa((item.m11_actual_quantity / item.m11_target_quantity) * 100, item.m11_target_quantity) + "%",
                m12: this.SumSuanFa((item.m12_actual_quantity / item.m12_target_quantity) * 100, item.m12_target_quantity) + "%",
              };
              item.tableData2.push(target);
              item.tableData2.push(forecast);
              item.tableData2.push(actual);
              item.tableData2.push(dcl);
            }
            self.allArray[tab.index].arr = res.data;
            this.$forceUpdate();
            self.loading = false;
          }
        });
      } catch (e) {}
    },

    async getEditSalesList() {
      try {
        this.loading = true;
        let data = {
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          territory_id: this.sonNodeKey,
          territory_type: "ENDPOINT",
          saleYear: this.saleYear,
          data_type: this.key2,
        };
        await http.post("/wapi/sales/getEditSalesList", data).then((res) => {
          if (res.success) {
            this.SalesListArray = [];
            this.editAllArray = [];
            if (res.data.skuArray.length > 0) {
              this.SalesListArray = res.data.skuArray;
              this.dialogActive1 = this.SalesListArray[0].sku_id;

              // for (let i = 0; i < res.data.array.length; i++) {
              let array = res.data.array;
              let item = this.SalesListArray[0];
              item.tableData = [];

              for (let j = 0; j < array.length; j++) {
                let o = array[j];
                item.sku_name = this.key2 == "PRODUCT" ? o.sku_name : o.name;
                item.id = o.id;
                let target = {
                  title: "指标",
                  sort: parseInt(j) + 1,
                  name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                  type: o.type,
                  key_id: o.key_id,
                  product_id: o.product_id,
                  sku_id: o.sku_id,
                  id: o.id,
                  m1: o.m1_target_quantity,
                  m2: o.m2_target_quantity,
                  m3: o.m3_target_quantity,
                  m4: o.m4_target_quantity,
                  m5: o.m5_target_quantity,
                  m6: o.m6_target_quantity,
                  m7: o.m7_target_quantity,
                  m8: o.m8_target_quantity,
                  m9: o.m9_target_quantity,
                  m10: o.m10_target_quantity,
                  m11: o.m11_target_quantity,
                  m12: o.m12_target_quantity,
                };
                let forecast = {
                  title: "预估",
                  sort: parseInt(j) + 1,
                  name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                  type: o.type,
                  key_id: o.key_id,
                  product_id: o.product_id,
                  sku_id: o.sku_id,
                  id: o.id,
                  m1: o.m1_forecast_quantity,
                  m2: o.m2_forecast_quantity,
                  m3: o.m3_forecast_quantity,
                  m4: o.m4_forecast_quantity,
                  m5: o.m5_forecast_quantity,
                  m6: o.m6_forecast_quantity,
                  m7: o.m7_forecast_quantity,
                  m8: o.m8_forecast_quantity,
                  m9: o.m9_forecast_quantity,
                  m10: o.m10_forecast_quantity,
                  m11: o.m11_forecast_quantity,
                  m12: o.m12_forecast_quantity,
                };
                let actual = {
                  title: "实际",
                  sort: parseInt(j) + 1,
                  name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                  type: o.type,
                  key_id: o.key_id,
                  product_id: o.product_id,
                  sku_id: o.sku_id,
                  id: o.id,
                  m1: o.m1_actual_quantity,
                  m2: o.m2_actual_quantity,
                  m3: o.m3_actual_quantity,
                  m4: o.m4_actual_quantity,
                  m5: o.m5_actual_quantity,
                  m6: o.m6_actual_quantity,
                  m7: o.m7_actual_quantity,
                  m8: o.m8_actual_quantity,
                  m9: o.m9_actual_quantity,
                  m10: o.m10_actual_quantity,
                  m11: o.m11_actual_quantity,
                  m12: o.m12_actual_quantity,
                };
                let dcl = {
                  title: "达成率",
                  sort: parseInt(j) + 1,
                  name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                  type: o.type,
                  key_id: o.key_id,
                  product_id: o.product_id,
                  sku_id: o.sku_id,
                  m1: this.SumSuanFa(((o.m1_actual_quantity / o.m1_target_quantity) * 100).toFixed(1), o.m1_target_quantity) + "%",
                  m2: this.SumSuanFa(((o.m2_actual_quantity / o.m2_target_quantity) * 100).toFixed(1), o.m2_target_quantity) + "%",
                  m3: this.SumSuanFa(((o.m3_actual_quantity / o.m3_target_quantity) * 100).toFixed(1), o.m3_target_quantity) + "%",
                  m4: this.SumSuanFa(((o.m4_actual_quantity / o.m4_target_quantity) * 100).toFixed(1), o.m4_target_quantity) + "%",
                  m5: this.SumSuanFa(((o.m5_actual_quantity / o.m5_target_quantity) * 100).toFixed(1), o.m5_target_quantity) + "%",
                  m6: this.SumSuanFa(((o.m6_actual_quantity / o.m6_target_quantity) * 100).toFixed(1), o.m6_target_quantity) + "%",
                  m7: this.SumSuanFa(((o.m7_actual_quantity / o.m7_target_quantity) * 100).toFixed(1), o.m7_target_quantity) + "%",
                  m8: this.SumSuanFa(((o.m8_actual_quantity / o.m8_target_quantity) * 100).toFixed(1), o.m8_target_quantity) + "%",
                  m9: this.SumSuanFa(((o.m9_actual_quantity / o.m9_target_quantity) * 100).toFixed(1), o.m9_target_quantity) + "%",
                  m10: this.SumSuanFa(((o.m10_actual_quantity / o.m10_target_quantity) * 100).toFixed(1), o.m10_target_quantity) + "%",
                  m11: this.SumSuanFa(((o.m11_actual_quantity / o.m11_target_quantity) * 100).toFixed(1), o.m11_target_quantity) + "%",
                  m12: this.SumSuanFa(((o.m12_actual_quantity / o.m12_target_quantity) * 100).toFixed(1), o.m12_target_quantity) + "%",
                };

                item.tableData.push(target);
                item.tableData.push(forecast);
                item.tableData.push(actual);
                item.tableData.push(dcl);
              }
              // if (array.length > 0) {
              //     this.SalesListArray[0].tableData = item
              // }
              this.loading = false;
              // }
            } else if (res.data.allArray.length > 0) {
              this.editAllArray = res.data.allArray;
              this.dialogActive2 = this.editAllArray[0].institution_id || this.editAllArray[0].store_id || this.editAllArray[0].distributor_id;

              // for (let i = 0; i < res.data.array.length; i++) {
              let array = res.data.array;
              let item = this.editAllArray[0];
              item.tableData = [];

              for (let j = 0; j < array.length; j++) {
                let o = array[j];
                item.sku_name = this.key2 == "PRODUCT" ? o.sku_name : o.name;

                let target = {
                  title: "指标",
                  sort: parseInt(j) + 1,
                  name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                  type: o.type,
                  key_id: o.key_id,
                  product_id: o.product_id,
                  sku_id: o.sku_id,
                  id: o.id,
                  m1: o.m1_target_quantity,
                  m2: o.m2_target_quantity,
                  m3: o.m3_target_quantity,
                  m4: o.m4_target_quantity,
                  m5: o.m5_target_quantity,
                  m6: o.m6_target_quantity,
                  m7: o.m7_target_quantity,
                  m8: o.m8_target_quantity,
                  m9: o.m9_target_quantity,
                  m10: o.m10_target_quantity,
                  m11: o.m11_target_quantity,
                  m12: o.m12_target_quantity,
                };
                let forecast = {
                  title: "预估",
                  sort: parseInt(j) + 1,
                  name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                  type: o.type,
                  key_id: o.key_id,
                  product_id: o.product_id,
                  sku_id: o.sku_id,
                  id: o.id,
                  m1: o.m1_forecast_quantity,
                  m2: o.m2_forecast_quantity,
                  m3: o.m3_forecast_quantity,
                  m4: o.m4_forecast_quantity,
                  m5: o.m5_forecast_quantity,
                  m6: o.m6_forecast_quantity,
                  m7: o.m7_forecast_quantity,
                  m8: o.m8_forecast_quantity,
                  m9: o.m9_forecast_quantity,
                  m10: o.m10_forecast_quantity,
                  m11: o.m11_forecast_quantity,
                  m12: o.m12_forecast_quantity,
                };
                let actual = {
                  title: "实际",
                  sort: parseInt(j) + 1,
                  name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                  type: o.type,
                  key_id: o.key_id,
                  product_id: o.product_id,
                  sku_id: o.sku_id,
                  id: o.id,
                  m1: o.m1_actual_quantity,
                  m2: o.m2_actual_quantity,
                  m3: o.m3_actual_quantity,
                  m4: o.m4_actual_quantity,
                  m5: o.m5_actual_quantity,
                  m6: o.m6_actual_quantity,
                  m7: o.m7_actual_quantity,
                  m8: o.m8_actual_quantity,
                  m9: o.m9_actual_quantity,
                  m10: o.m10_actual_quantity,
                  m11: o.m11_actual_quantity,
                  m12: o.m12_actual_quantity,
                };
                let dcl = {
                  title: "达成率",
                  sort: parseInt(j) + 1,
                  name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                  type: o.type,
                  key_id: o.key_id,
                  product_id: o.product_id,
                  sku_id: o.sku_id,
                  m1: this.SumSuanFa(((o.m1_actual_quantity / o.m1_target_quantity) * 100).toFixed(1), o.m1_target_quantity) + "%",
                  m2: this.SumSuanFa(((o.m2_actual_quantity / o.m2_target_quantity) * 100).toFixed(1), o.m2_target_quantity) + "%",
                  m3: this.SumSuanFa(((o.m3_actual_quantity / o.m3_target_quantity) * 100).toFixed(1), o.m3_target_quantity) + "%",
                  m4: this.SumSuanFa(((o.m4_actual_quantity / o.m4_target_quantity) * 100).toFixed(1), o.m4_target_quantity) + "%",
                  m5: this.SumSuanFa(((o.m5_actual_quantity / o.m5_target_quantity) * 100).toFixed(1), o.m5_target_quantity) + "%",
                  m6: this.SumSuanFa(((o.m6_actual_quantity / o.m6_target_quantity) * 100).toFixed(1), o.m6_target_quantity) + "%",
                  m7: this.SumSuanFa(((o.m7_actual_quantity / o.m7_target_quantity) * 100).toFixed(1), o.m7_target_quantity) + "%",
                  m8: this.SumSuanFa(((o.m8_actual_quantity / o.m8_target_quantity) * 100).toFixed(1), o.m8_target_quantity) + "%",
                  m9: this.SumSuanFa(((o.m9_actual_quantity / o.m9_target_quantity) * 100).toFixed(1), o.m9_target_quantity) + "%",
                  m10: this.SumSuanFa(((o.m10_actual_quantity / o.m10_target_quantity) * 100).toFixed(1), o.m10_target_quantity) + "%",
                  m11: this.SumSuanFa(((o.m11_actual_quantity / o.m11_target_quantity) * 100).toFixed(1), o.m11_target_quantity) + "%",
                  m12: this.SumSuanFa(((o.m12_actual_quantity / o.m12_target_quantity) * 100).toFixed(1), o.m12_target_quantity) + "%",
                };

                item.tableData.push(target);
                item.tableData.push(forecast);
                item.tableData.push(actual);
                item.tableData.push(dcl);
              }
              // if (array.length > 0) {
              //     this.SalesListArray[0].tableData = item
              // }
              this.loading = false;
            }
          } else {
            Message.error(res.message);
          }
          this.loading = false;
        });
      } catch (e) {}
    },
    async getEditSkuInfo(tab) {
      try {
        let self = this;
        let obj = self.SalesListArray[tab.index];
        self.loading = true;
        let data = {
          skuObj: obj,
          territory_id: this.sonNodeKey,
          tenant_id: this.$store.getters.getUser.tenant_id,
          saleYear: this.saleYear,
        };
        await http.post("/wapi/sales/getEndTerritorySkuInfo", data).then((res) => {
          if (res.success) {
            let array = res.data;
            let item = self.SalesListArray[tab.index];
            item.tableData = [];
            for (let j = 0; j < array.length; j++) {
              let o = array[j];
              item.sku_name = this.key2 == "PRODUCT" ? o.sku_name : o.name;

              let target = {
                title: "指标",
                sort: parseInt(j) + 1,
                name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                type: o.type,
                key_id: o.key_id,
                product_id: o.product_id,
                sku_id: o.sku_id,
                id: o.id,
                m1: o.m1_target_quantity,
                m2: o.m2_target_quantity,
                m3: o.m3_target_quantity,
                m4: o.m4_target_quantity,
                m5: o.m5_target_quantity,
                m6: o.m6_target_quantity,
                m7: o.m7_target_quantity,
                m8: o.m8_target_quantity,
                m9: o.m9_target_quantity,
                m10: o.m10_target_quantity,
                m11: o.m11_target_quantity,
                m12: o.m12_target_quantity,
              };
              let forecast = {
                title: "预估",
                sort: parseInt(j) + 1,
                name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                type: o.type,
                key_id: o.key_id,
                product_id: o.product_id,
                sku_id: o.sku_id,
                id: o.id,
                m1: o.m1_forecast_quantity,
                m2: o.m2_forecast_quantity,
                m3: o.m3_forecast_quantity,
                m4: o.m4_forecast_quantity,
                m5: o.m5_forecast_quantity,
                m6: o.m6_forecast_quantity,
                m7: o.m7_forecast_quantity,
                m8: o.m8_forecast_quantity,
                m9: o.m9_forecast_quantity,
                m10: o.m10_forecast_quantity,
                m11: o.m11_forecast_quantity,
                m12: o.m12_forecast_quantity,
              };
              let actual = {
                title: "实际",
                sort: parseInt(j) + 1,
                name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                type: o.type,
                key_id: o.key_id,
                product_id: o.product_id,
                sku_id: o.sku_id,
                id: o.id,
                m1: o.m1_actual_quantity,
                m2: o.m2_actual_quantity,
                m3: o.m3_actual_quantity,
                m4: o.m4_actual_quantity,
                m5: o.m5_actual_quantity,
                m6: o.m6_actual_quantity,
                m7: o.m7_actual_quantity,
                m8: o.m8_actual_quantity,
                m9: o.m9_actual_quantity,
                m10: o.m10_actual_quantity,
                m11: o.m11_actual_quantity,
                m12: o.m12_actual_quantity,
              };
              let dcl = {
                title: "达成率",
                sort: parseInt(j) + 1,
                name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                type: o.type,
                key_id: o.key_id,
                product_id: o.product_id,
                sku_id: o.sku_id,
                m1: this.SumSuanFa(((o.m1_actual_quantity / o.m1_target_quantity) * 100).toFixed(1), o.m1_target_quantity) + "%",
                m2: this.SumSuanFa(((o.m2_actual_quantity / o.m2_target_quantity) * 100).toFixed(1), o.m2_target_quantity) + "%",
                m3: this.SumSuanFa(((o.m3_actual_quantity / o.m3_target_quantity) * 100).toFixed(1), o.m3_target_quantity) + "%",
                m4: this.SumSuanFa(((o.m4_actual_quantity / o.m4_target_quantity) * 100).toFixed(1), o.m4_target_quantity) + "%",
                m5: this.SumSuanFa(((o.m5_actual_quantity / o.m5_target_quantity) * 100).toFixed(1), o.m5_target_quantity) + "%",
                m6: this.SumSuanFa(((o.m6_actual_quantity / o.m6_target_quantity) * 100).toFixed(1), o.m6_target_quantity) + "%",
                m7: this.SumSuanFa(((o.m7_actual_quantity / o.m7_target_quantity) * 100).toFixed(1), o.m7_target_quantity) + "%",
                m8: this.SumSuanFa(((o.m8_actual_quantity / o.m8_target_quantity) * 100).toFixed(1), o.m8_target_quantity) + "%",
                m9: this.SumSuanFa(((o.m9_actual_quantity / o.m9_target_quantity) * 100).toFixed(1), o.m9_target_quantity) + "%",
                m10: this.SumSuanFa(((o.m10_actual_quantity / o.m10_target_quantity) * 100).toFixed(1), o.m10_target_quantity) + "%",
                m11: this.SumSuanFa(((o.m11_actual_quantity / o.m11_target_quantity) * 100).toFixed(1), o.m11_target_quantity) + "%",
                m12: this.SumSuanFa(((o.m12_actual_quantity / o.m12_target_quantity) * 100).toFixed(1), o.m12_target_quantity) + "%",
              };

              item.tableData.push(target);
              item.tableData.push(forecast);
              item.tableData.push(actual);
              item.tableData.push(dcl);
            }
            self.loading = false;
          }
        });
      } catch (e) {}
    },
    async getEditClientInfo(tab) {
      try {
        let self = this;
        let obj = self.editAllArray[tab.index];
        self.loading = true;
        let data = {
          clientObj: obj,
          territory_id: this.sonNodeKey,
          tenant_id: this.$store.getters.getUser.tenant_id,
          saleYear: this.saleYear,
        };
        await http.post("/wapi/sales/getEndTerritoryClientInfo", data).then((res) => {
          if (res.success) {
            let array = res.data;
            let item = self.editAllArray[tab.index];
            item.tableData = [];
            for (let j = 0; j < array.length; j++) {
              let o = array[j];
              item.sku_name = this.key2 == "PRODUCT" ? o.sku_name : o.name;

              let target = {
                title: "指标",
                sort: parseInt(j) + 1,
                name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                type: o.type,
                key_id: o.key_id,
                product_id: o.product_id,
                sku_id: o.sku_id,
                id: o.id,
                m1: o.m1_target_quantity,
                m2: o.m2_target_quantity,
                m3: o.m3_target_quantity,
                m4: o.m4_target_quantity,
                m5: o.m5_target_quantity,
                m6: o.m6_target_quantity,
                m7: o.m7_target_quantity,
                m8: o.m8_target_quantity,
                m9: o.m9_target_quantity,
                m10: o.m10_target_quantity,
                m11: o.m11_target_quantity,
                m12: o.m12_target_quantity,
              };
              let forecast = {
                title: "预估",
                sort: parseInt(j) + 1,
                name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                type: o.type,
                key_id: o.key_id,
                product_id: o.product_id,
                sku_id: o.sku_id,
                id: o.id,
                m1: o.m1_forecast_quantity,
                m2: o.m2_forecast_quantity,
                m3: o.m3_forecast_quantity,
                m4: o.m4_forecast_quantity,
                m5: o.m5_forecast_quantity,
                m6: o.m6_forecast_quantity,
                m7: o.m7_forecast_quantity,
                m8: o.m8_forecast_quantity,
                m9: o.m9_forecast_quantity,
                m10: o.m10_forecast_quantity,
                m11: o.m11_forecast_quantity,
                m12: o.m12_forecast_quantity,
              };
              let actual = {
                title: "实际",
                sort: parseInt(j) + 1,
                name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                type: o.type,
                key_id: o.key_id,
                product_id: o.product_id,
                sku_id: o.sku_id,
                id: o.id,
                m1: o.m1_actual_quantity,
                m2: o.m2_actual_quantity,
                m3: o.m3_actual_quantity,
                m4: o.m4_actual_quantity,
                m5: o.m5_actual_quantity,
                m6: o.m6_actual_quantity,
                m7: o.m7_actual_quantity,
                m8: o.m8_actual_quantity,
                m9: o.m9_actual_quantity,
                m10: o.m10_actual_quantity,
                m11: o.m11_actual_quantity,
                m12: o.m12_actual_quantity,
              };
              let dcl = {
                title: "达成率",
                sort: parseInt(j) + 1,
                name: this.key2 == "PRODUCT" ? o.name : o.sku_name,
                type: o.type,
                key_id: o.key_id,
                product_id: o.product_id,
                sku_id: o.sku_id,
                m1: this.SumSuanFa(((o.m1_actual_quantity / o.m1_target_quantity) * 100).toFixed(1), o.m1_target_quantity) + "%",
                m2: this.SumSuanFa(((o.m2_actual_quantity / o.m2_target_quantity) * 100).toFixed(1), o.m2_target_quantity) + "%",
                m3: this.SumSuanFa(((o.m3_actual_quantity / o.m3_target_quantity) * 100).toFixed(1), o.m3_target_quantity) + "%",
                m4: this.SumSuanFa(((o.m4_actual_quantity / o.m4_target_quantity) * 100).toFixed(1), o.m4_target_quantity) + "%",
                m5: this.SumSuanFa(((o.m5_actual_quantity / o.m5_target_quantity) * 100).toFixed(1), o.m5_target_quantity) + "%",
                m6: this.SumSuanFa(((o.m6_actual_quantity / o.m6_target_quantity) * 100).toFixed(1), o.m6_target_quantity) + "%",
                m7: this.SumSuanFa(((o.m7_actual_quantity / o.m7_target_quantity) * 100).toFixed(1), o.m7_target_quantity) + "%",
                m8: this.SumSuanFa(((o.m8_actual_quantity / o.m8_target_quantity) * 100).toFixed(1), o.m8_target_quantity) + "%",
                m9: this.SumSuanFa(((o.m9_actual_quantity / o.m9_target_quantity) * 100).toFixed(1), o.m9_target_quantity) + "%",
                m10: this.SumSuanFa(((o.m10_actual_quantity / o.m10_target_quantity) * 100).toFixed(1), o.m10_target_quantity) + "%",
                m11: this.SumSuanFa(((o.m11_actual_quantity / o.m11_target_quantity) * 100).toFixed(1), o.m11_target_quantity) + "%",
                m12: this.SumSuanFa(((o.m12_actual_quantity / o.m12_target_quantity) * 100).toFixed(1), o.m12_target_quantity) + "%",
              };

              item.tableData.push(target);
              item.tableData.push(forecast);
              item.tableData.push(actual);
              item.tableData.push(dcl);
            }
            self.loading = false;
          }
        });
      } catch (e) {}
    },

    async saveSalesByEndPoint() {
      try {
        let data_array = [];
        let array = [];
        if (this.key2 === "INSTITUTION") {
          array = this.editAllArray;
        } else if (this.key2 === "PRODUCT") {
          array = this.SalesListArray;
        }
        //0,1               //8/4=2
        for (let i = 0; i < array.length; i++) {
          let item = array[i];

          if (item.tableData && item.tableData.length > 0) {
            for (var j = 0; j < item.tableData.length / 4; j++) {
              let obj = {};
              let targetObj = item.tableData[j * 4];
              let forecastObj = item.tableData[j * 4 + 1];
              let actualObj = item.tableData[j * 4 + 2];

              obj.type = targetObj.type;
              obj.key_id = targetObj.key_id;
              obj.sku_id = targetObj.sku_id;
              obj.product_id = targetObj.product_id;
              obj.id = targetObj.id;

              obj.m1_target_quantity = targetObj.m1;
              obj.m2_target_quantity = targetObj.m2;
              obj.m3_target_quantity = targetObj.m3;
              obj.m4_target_quantity = targetObj.m4;
              obj.m5_target_quantity = targetObj.m5;
              obj.m6_target_quantity = targetObj.m6;
              obj.m7_target_quantity = targetObj.m7;
              obj.m8_target_quantity = targetObj.m7;
              obj.m9_target_quantity = targetObj.m9;
              obj.m10_target_quantity = targetObj.m10;
              obj.m11_target_quantity = targetObj.m11;
              obj.m12_target_quantity = targetObj.m12;

              obj.m1_forecast_quantity = forecastObj.m1;
              obj.m2_forecast_quantity = forecastObj.m2;
              obj.m3_forecast_quantity = forecastObj.m3;
              obj.m4_forecast_quantity = forecastObj.m4;
              obj.m5_forecast_quantity = forecastObj.m5;
              obj.m6_forecast_quantity = forecastObj.m6;
              obj.m7_forecast_quantity = forecastObj.m7;
              obj.m8_forecast_quantity = forecastObj.m8;
              obj.m9_forecast_quantity = forecastObj.m9;
              obj.m10_forecast_quantity = forecastObj.m10;
              obj.m11_forecast_quantity = forecastObj.m11;
              obj.m12_forecast_quantity = forecastObj.m12;

              obj.m1_actual_quantity = actualObj.m1;
              obj.m2_actual_quantity = actualObj.m2;
              obj.m3_actual_quantity = actualObj.m3;
              obj.m4_actual_quantity = actualObj.m4;
              obj.m5_actual_quantity = actualObj.m5;
              obj.m6_actual_quantity = actualObj.m6;
              obj.m7_actual_quantity = actualObj.m7;
              obj.m8_actual_quantity = actualObj.m8;
              obj.m9_actual_quantity = actualObj.m9;
              obj.m10_actual_quantity = actualObj.m10;
              obj.m11_actual_quantity = actualObj.m11;
              obj.m12_actual_quantity = actualObj.m12;

              data_array.push(obj);
            }
          }
        }

        this.loading = true;
        let data = {
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          data_array: data_array,
          saleYear: this.saleYear,
        };
        await http.post("/wapi/sales/saveSalesByEndPoint", data).then((res) => {
          if (res.success) {
            this.getTerritoryListByEndPoint();
          } else {
            Message.error(res.message);
            this.loading = false;
          }
          //                        this.loading = false
        });
      } catch (e) {}
    },
    clickLeft() {
      this.saleYear = Number(this.saleYear) - 1;
      this.init();
    },
    clickRight() {
      this.saleYear = Number(this.saleYear) + 1;
      this.init();
    },
    dialogClickLeft() {
      this.saleYear = Number(this.saleYear) - 1;
      this.getEditSalesList();
    },
    dialogClickRight() {
      this.saleYear = Number(this.saleYear) + 1;
      this.getEditSalesList();
    },
    async search(queryString, cb) {
      this.queryString = queryString.trim();
      if (queryString) {
        try {
          var user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
            search: this.queryString,
            month: moment().format("YYYYMM"),
          };

          await http.post("/wapi/sales/searchTerritory", data).then((res) => {
            if (res.success) {
              cb(res.data);
            }
          });
        } catch (err) {
          this.error();
        }
      } else {
        cb([]);
        // this.$refs.tree.filter();
      }
    },
    filterNode() {},
    handleSelect(item) {
      this.sonNodeKey = item.territory_id;
      this.nodeData = item;
      this.tableData = [];
      this.territory_name = item.territory_name;
      this.territory_level_name = item.territory_level_name;
      if (item.territory_type === "CONTAINER") {
        this.territory_region = "地区";
        this.getTerritoryListByContainer();
        this.terminal = false;
        debugger;
      } else {
        this.key = "PRODUCT";
        this.getTerritoryListByEndPoint();
        this.terminal = true;
        this.territory_region = "终端";
      }
      debugger;
      this.territory_code = item.territory_code;
      this.owner_name = item.owner_name;
      this.owner_title = item.title;
      this.salList = item.isManage;
      this.selectedTerritory = item.territory_id;
      this.$refs.tree.setCurrentKey(item.territory_id);
      this.input = "";
    },
  },
  created() {
    this.init();

    this.date = parseInt(new Date().Format("MM")) + "月";
    this.saleYear = moment().format("YYYY");
  },
  // mounted() {
  //
  // },
  // updated() {
  // },
  //
  // computed: {},
  watch: {
    activeNameImp(val, old) {
      if (val !== old) {
        this.tabsChange();
      }
    },
  },
};
</script>

<style lang="scss" module>
.container {
  background: white;
  height: 100%;
  overflow: auto;
  .left {
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    .search {
      width: 360px;
    }
    .type {
      em {
        color: #d98f2f;
        font-size: 14px;
        font-weight: bold;
      }
    }

    .first {
      color: #555555;
      font-size: 20px;
    }
    .font {
      font-size: 14px;
      color: #555555;
    }
  }
  .right {
    margin-top: -20px;
    width: 100%;
    .header {
      width: 100%;
      padding-bottom: 6px;
      border-bottom: 2px dotted #e7eaec;
    }
    .body {
      overflow: auto;
    }
  }
}
</style>
<style>
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #e6f1fc;
  color: #2b92fa;
}

.el-container {
  height: 100%;
  padding: 20px;
  background: white;
}

#inputSeach {
  padding: 0px;
  border: none;
  border-radius: 5px;
  background: rgba(3, 3, 3, 0.1);
  height: 30px;
  text-align: center;
}

#el-rowInput .el-input {
  width: 338px;
  padding: 5px 10px;
  border: 1px solid #dedede;
}
#loading .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0px 0 5px;
}
</style>
<style scoped>
.subjectList >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: right;
  font-weight: bold;
}
.SizeClass1 >>> .el-tree-node:focus > .el-tree-node__content {
  background-color: #d8f6ee;
}

.SizeClass1 >>> .el-tree-node__content {
  height: 40px;
  line-height: 40px;
}

#regionP {
  margin-left: 5px;
  padding: 5px 14px;
  display: inline-block;
  font-size: 12px;
  border: 1px solid #db4dd7;
  color: #db4dd7;
  border-radius: 4px;
}

.el-radio-button__inner,
.el-radio-group {
  display: block;
}
.inputStyle {
  border-radius: 3px;
  height: 20px;
  border: 1px solid #ededed;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/changzhou/home.vue